import React from 'react';
import NavigationMenuEUWeb from '../../../components/src/NavigationMenuEU.web';
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  Modal,
  Divider,
  Avatar,
  Popover,
  MenuItem,
  ListItemText,
  TextField,
  Paper,
} from '@material-ui/core';
import SuggestedBrands from '../../../components/src/SuggestedBrands';
import { Swiper, SwiperSlide } from 'swiper/react';
import MobileNavEndUser from '../../dashboard/src/MobileNavEndUser.web';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import {
  createStyles,
  styled,
  Theme,
  withStyles
} from "@material-ui/core/styles";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import MoreHorizRoundedIcon from '@material-ui/icons/MoreHorizRounded';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import moment from "moment";
import clsx from "clsx";
import SwiperCore, { Navigation, Pagination } from 'swiper';
import UserProfileController from './UserProfileController.web';
import CustomLoader from '../../../components/src/CustomLoader.web';
import CustomButton from '../../../components/src/CustomButton.web';
import { nextSliderArrow } from '../../dashboard/src/assets';
import TopActiveUsersEU from '../../dashboard/src/TopActiveUsersEu.web';
import { Play } from './assets';
import Poll from "../../dashboard/src/Poll.web";
import { CommentIconWhite, HeartSmallIcon, redHeart, uploadIcon, sendMedssageIcon } from "../../dashboard/src/assets";
import { IconAvtar } from "../../contactlist/src/assets";
import CommentImage from "../../../components/src/CommentImage.web";
import CustomConditionalRender from "../../../components/src/CustomConditionalRender.web";
import { handleOrConditions } from "../../../components/src/CommonFunctions";
import { Message } from "../../../framework/src/Message";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
const dashboardConfigJSON = require("../../dashboard/src/config.js");

SwiperCore.use([Navigation, Pagination]);

export class EuuserProfile extends UserProfileController {
  // Refs for video management (Instagram-style post modal)
  reelVideoRefs = new Map<string, HTMLVideoElement>();
  currentPostIndexRef = { current: 0 };
  currentPostSlideRef = { current: 0 };
  processedImagesRef = { current: new Set<string>() };
  processedVideosRef = { current: new Set<string>() };
  imageResizeModes = new Map<string, string>();
  videoResizeModes = new Map<string, string>();
  isMobile = false;

  constructor(props: any) {
    super(props);

    this.state = {
      ...this.state,
      previewModalId: null,
      selectedPost: null,
      currentPostIndex: 0,
      currentPostSlide: 0,
      swiperInstance: null,
      expandedDescriptions: new Set(),
      postPreviewComment: false,
    } as any;

    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth < 600;
    }
  }

  render() {
    const { classes, navigation }: any = this.props;
    const { top6BrandProfile, profileDataEU } = this.state

    return (
      <RootContainer>
        <style>{`
          html, body, #root, #root > div {
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          html::-webkit-scrollbar,
          body::-webkit-scrollbar,
          #root::-webkit-scrollbar,
          #root > div::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <NavigationMenuEUWeb brands={this.state.brandsIFollow}/>
        {this.state.circularLoaderEu ? <CustomLoader loaderSize={24} isLoading={this.state.circularLoaderEu}/> :
        <div className={classes.profileContentWrapper} >
          <Box paddingX={3} className='asdf'>
            <Box className={classes.followersCarouselContainer}>
              <Typography className={classes.followersCarouselHeading}>Followers</Typography>
              {this.state.followersData?.followers?.data?.length > 0 ? (
                <Box style={{ position: "relative" }}>
                  <div className={classes.swiperLeftBtn}>
                    <img src={nextSliderArrow} className="followers-swiper-prev" style={{ height: "20px", width: "20px", color: "#334155", cursor: "pointer", transform: "rotate(180deg)" }} />
                  </div>
                  <Swiper
                    spaceBetween={4}
                    slidesPerView={window.innerWidth < 650 ? 3 : 5}
                    navigation={{
                      nextEl: '.followers-swiper-next',
                      prevEl: '.followers-swiper-prev',
                    }}
                  >
                    {this.state.followersData.followers.data.map((follower: any, index: number) => (
                      <SwiperSlide key={follower.id || index}>
                        <Box className={classes.followerAvatarBox}>
                          <img
                            className={classes.followerAvatarImg}
                            src={follower.attributes.profile_pic ? follower.attributes.profile_pic.url : `https://avatar.iran.liara.run/public/${index + 1}`}
                            alt={follower.attributes.full_name || follower.attributes.first_name}
                          />
                          <Typography className={classes.followerName}>
                            {follower.attributes.full_name || `${follower.attributes.first_name} ${follower.attributes.last_name}`}
                          </Typography>
                        </Box>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className={classes.swiperRightBtn}>
                    <img src={nextSliderArrow} className="followers-swiper-next" style={{ height: "20px", width: "20px", color: "#334155", cursor: "pointer" }} />
                  </div>
                </Box>
              ) : (
                <Typography className={classes.followersCarouselHeading}>No followers found</Typography>
              )}
            </Box>
            <Grid  container spacing={3}>
              <Grid item xs={12} sm={7} md={6} lg={8} style={{padding: "0px"}}>
                <Box  className={classes.ebEuProfileContainer}>
                  <Box className={classes.imageOverlay}>
                    <Box className={classes.profileImageContainer}>
                      {this.state.profileDataEU.photo && <img 
                        className={classes.image} 
                        src={this.state.profileDataEU.photo} 
                        alt="Profile Slide 1"
                      />}                    
                    </Box>
                  </Box>
                  {!this.state.userID && <Box className={classes.editIconContainer} data-test-id={"eu-profile-edit-btn"} onClick={()=>this.handleNavigateEditProfile()}>
                      <EditOutlinedIcon />
                  </Box>}
                  <Box className={classes.detailsContainer}>
                    <Box className='residenceTextContainer'>
                      <Typography variant="body2" className='residenceText'>{`${this.state.profileDataEU.city || ""}${this.state.profileDataEU.city ? "," : ""} ${this.state.profileDataEU.country || ""}`}</Typography>
                    </Box>
                    <Typography className='nameText' variant="h3" style={{fontWeight: 700}}>{this.state.profileDataEU.name || ""}</Typography>
                    <Typography variant="body2" className='headline'>{this.state.profileDataEU.headline || ""}</Typography>
                    {this.state.userID && this.state.selfProfile === "false" && <Button variant="contained" data-test-id="user-follow-btn" color="primary" className={classes.followBtn} onClick={()=>this.followBrandApiProfile(this.state.userID, true, this.state.isFollowing)}>{this.state.isFollowing ? "Following" : "Follow"}</Button>}
                  </Box>
                  <Box className={classes.followContainer}>
                    <Box>
                      <Typography variant="h4" className="followersFollowingNumber">{this.state.profileDataEU.followers}</Typography>
                      <Typography variant="h6" className={classes.fontWeight}>Followers</Typography>
                    </Box>
                    <Box>
                      <Typography variant="h4" className="followersFollowingNumber">{this.state.profileDataEU.following}</Typography>
                      <Typography variant="h6" className={classes.fontWeight}>Following</Typography>
                    </Box>
                  </Box>
                </Box>
                <Box>
                {profileDataEU.personality_prompt.length > 0 ?
                  <Box className={classes.ebSwiperBox} data-test-id="swiperContainer">
                    <div className={classes.swiperLeftBtn}>
                      <img src={nextSliderArrow} className="swiper-button-prev" style={{ height: "20px", width: "20px", color: "#334155", cursor: "pointer", transform: "rotate(180deg)" }} />
                    </div>
                  <Swiper
                      onSwiper={this.onSwipe}
                      onSlideChange={this.onSlideChange}
                      slidesPerView={1}
                      navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                      }}
                    >
                      {profileDataEU.personality_prompt.map((presonalityPompt) => (
                        <SwiperSlide className={classes.ebSwiperSlideContainer}>
                        <Box sx={{ position: 'relative' }}>
                          <Box className={classes.sliderBottomContainer} sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                            <Box>
                            <Typography variant="h5" className={classes.subHeading1}>
                              {presonalityPompt.question}
                            </Typography>
                            <Typography variant="h5" className={classes.subHeading2}>
                              {presonalityPompt.answer}
                            </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </SwiperSlide>
                      ))}
                    </Swiper>
                    <div className={classes.swiperRightBtn}>
                      <img src={nextSliderArrow} className="swiper-button-next" style={{ height: "20px", width: "20px", color: "#334155", cursor: "pointer" }} />
                    </div>
                  </Box>
                  :
                  <Box className={classes.addPersonalityWrapper}  style={ this.state.userID ? {display: "none"} : {padding: "15px 20px"}}>
                    <CustomButton onClick={this.handleNavigateEditProfile}>
                      Add Some Personality
                    </CustomButton>
                  </Box>
                }
                </Box>
                <Box>
                    <ul className={classes.slidesDotsUl}>
                    {this.state.profileDataEU.personality_prompt.map((_, index) => (<li className={index === this.state.currentSlide && classes.slidesDotsColor}>
                    </li>))}
                    </ul>
                  </Box>
                <Box className={classes.top6MobileView}>
                  <TopActiveUsersEU
                      navigation={navigation}
                      top6={top6BrandProfile}
                    />
                </Box>
                <Box style={{ padding: 2 }}>
                  <Typography variant='h5' className={classes.postsHeading}>Posts</Typography>
                  <Grid container spacing={2} style={{width: 'calc(100% + -4px)', margin: '2px'}}  key={"reelContainer"}>
                    {this.state.postsDataEU.map((reel, index) => (
                      <Grid item xs={4} key={reel.id} spacing={2} style={{padding: '5px 3px',}}>
                        <Box
                          className={classes.postThumbnailBox}
                          onClick={() => this.handleOpenPostModal(reel)}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={reel.attributes.thumbnail || `https://picsum.photos/id/${index + 10}/200/300`}
                            alt={`Post ${reel.id}`}
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                          <Box
                            style={{
                              position: 'absolute',
                              bottom: 6,
                              left: 10,
                              color: '#fff',
                              borderRadius: "100%",
                              fontWeight: 700,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              fontSize: "10px"
                            }}
                          >
                            <img src={Play} style={{width:'10px', height:'10px'}} />
                            <Typography style={{paddingTop: "4px", fontSize: "10px", fontWeight: 700}}>{reel.attributes.views_count}</Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Grid>
              <Grid item sm={5} md={4} xs={12} className={classes.top6AndFollowContainer}>
                <div>
                  <TopActiveUsersEU
                    navigation={navigation}
                    top6={top6BrandProfile}
                  />
                  <SuggestedBrands
                    brands={this.state.suggestedBrands}
                    followBrand={this.followBrandApiProfile}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>}
            {(this.state as any).previewModalId && (() => {
              const previewModalId = (this.state as any).previewModalId;
              const allPosts = this.state.postsDataEU || [];
              
              // Sort posts to match profile page order: trending first, then newest
              const sortedPosts = this.getSortedPostsForModal(allPosts);
              
              // Find the selected post from sortedPosts to ensure we have the latest data
              const selectedPost = sortedPosts.find((p: any) => p.id === previewModalId);
              if (!selectedPost) return null;
              
              const currentPostIndex = (this.state as any).currentPostIndex;
              const currentPostSlide = (this.state as any).currentPostSlide;
              const expandedDescriptions = (this.state as any).expandedDescriptions || new Set();
              const postPreviewComment = (this.state as any).postPreviewComment;
              
              return (
                <Modal
                  open={selectedPost.id === previewModalId}
                  onClose={this.handlePreviewModalClose}
                  className={this.props.classes.previewModal}
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                  BackdropProps={{
                    style: {
                      // backgroundColor: 'rgba(0, 0, 0, 0.95)',
                      backdropFilter: 'blur(5px)',
                    }
                  }}
                >
                  <Box 
                    className={this.props.classes.postViewContainer}
                    style={{
                      margin: 0,
                      padding: 0,
                      // Instagram Reels-style: Ensure proper touch handling on mobile
                      overscrollBehavior: 'contain', // Prevent page scroll when at edges
                      WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                    }}
                  >
                    <IconButton
                      data-test-id="previewCloseBtn"
                      onClick={this.handlePreviewModalClose}
                      className={this.props.classes.previewCloseBtn}
                    >
                      <CloseRoundedIcon fontSize="small" />
                    </IconButton>

                    {/* Instagram Reels Style Modal */}
                    {sortedPosts && sortedPosts.length > 0 ? (
                      <Swiper
                        key={`reels-modal-${previewModalId}`}
                        onSwiper={(swiper) => this.setSwiperInstance(swiper)}
                        onSlideChange={(swiper) => {
                          const newPostIndex = swiper.activeIndex;
                          
                          // CRITICAL: Update refs IMMEDIATELY so event handlers have latest values
                          this.currentPostIndexRef.current = newPostIndex;
                          this.currentPostSlideRef.current = 0;
                
                          // CRITICAL: Pause and mute ALL videos IMMEDIATELY before any state changes
                          // Method 1: Pause all videos in refs
                          this.reelVideoRefs.forEach((video) => {
                            if (video) {
                              // Force pause immediately
                              video.pause();
                              video.muted = true;
                              video.volume = 0;
                              // Remove autoplay attribute if present
                              video.removeAttribute('autoplay');
                            }
                          });
                          
                          // Method 2: Also query DOM directly to catch any videos we might have missed
                          const allVideosInDOM = document.querySelectorAll('video');
                          allVideosInDOM.forEach((video) => {
                            // NEVER play desktop feed videos
                            const isDesktopFeed = video.getAttribute('data-desktop-feed') === 'true';
                            if (isDesktopFeed) {
                              video.pause();
                              video.muted = true;
                              video.volume = 0;
                              video.removeAttribute('autoplay');
                              return; // Skip desktop feed videos
                            }
                            
                            const isInModal = video.closest('[class*="postViewContainer"], [class*="previewModal"]') !== null;
                            if (isInModal) {
                              video.pause();
                              video.muted = true;
                              video.volume = 0;
                              video.removeAttribute('autoplay');
                            }
                          });
                          
                          // Update state AFTER pausing all videos and updating refs
                          this.setCurrentPostIndex(newPostIndex);
                          this.setCurrentPostSlide(0);
                          
                          // Play video for the new post (works for both forward and backward navigation)
                          // Use requestAnimationFrame for smoother transitions
                          requestAnimationFrame(() => {
                            const currentPost = sortedPosts[newPostIndex];
                            if (currentPost && currentPost.attributes?.files && currentPost.attributes.files.length > 0) {
                              const firstFile = currentPost.attributes.files[0];
                              if (firstFile && firstFile.link_content_type?.includes("video")) {
                                const videoKey = currentPost.attributes.files.length > 1 
                                  ? `post-${currentPost.id}-0`
                                  : `post-${currentPost.id}`;
                                const video = this.reelVideoRefs.get(videoKey);
                                // Double-check index hasn't changed (prevent race conditions)
                                if (video && newPostIndex === this.currentPostIndexRef.current) {
                                  // Reset video to start for smooth playback
                                  video.currentTime = 0;
                                  video.muted = true;
                                  video.volume = 0;
                                  video.play().catch(err => {
                                    // Silently handle play errors (e.g., user interaction required)
                                    console.log('Video play failed:', err);
                                  });
                                }
                              }
                            }
                          });
                        }}
                        direction="vertical"
                        grabCursor={true}
                        style={{ height: '100%' }}
                        slidesPerView={1}
                        spaceBetween={0}
                        initialSlide={currentPostIndex}
                        // Instagram Reels: Mobile touch scrolling
                        allowTouchMove={true}
                        // Instagram Reels: Desktop mouse drag
                        simulateTouch={true}
                        // Instagram Reels: Desktop mousewheel scrolling
                        mousewheel={{
                          invert: false,
                          forceToAxis: true,
                          sensitivity: 1,
                          releaseOnEdges: true,
                        }}
                        // Instagram Reels: Keyboard navigation (both mobile and desktop)
                        keyboard={{
                          enabled: true,
                          onlyInViewport: true,
                        }}
                        pagination={false}
                        navigation={false}
            >
              {sortedPosts.map((post: any, postIdx: number) => {
                // Ensure we always use the latest post data from sortedPosts (trending first, then newest)
                const currentPost = sortedPosts[postIdx] || post;
                
                return (
                <SwiperSlide 
                  key={`post-${currentPost.id}-${postIdx}`} 
                  style={{ 
                    height: '100%', 
                    width: '100%',
                    // Let Swiper handle touch actions - don't override
                  }}
                >
                  <Box
                    style={{
                      position: 'relative',
                      height: '100%',
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      // Instagram Reels: Prevent text selection during swipe
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      // Instagram Reels: Smooth scrolling on iOS
                      WebkitOverflowScrolling: 'touch',
                    }}
                  >
                    {/* Post Media */}
                    {currentPost.attributes.files && currentPost.attributes.files.length > 0 && (
                      <Box
                        style={{
                          position: 'relative',
                          height: '100%',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          zIndex: 1, // Media layer - below overlays
                        }}
                      >
                        {currentPost.attributes.files.length > 1 ? (
                          <>
                            <Swiper
                              key={`post-${currentPost.id}-swiper`}
                              direction="horizontal"
                              grabCursor={true}
                              style={{ height: '100%', width: '100%' }}
                              slidesPerView={1}
                              spaceBetween={0}
                              onSlideChange={(swiper) => {
                                const newSlideIndex = swiper.activeIndex;
                                
                                // Only handle if this is the current post
                                if (postIdx !== currentPostIndex) {
                                  this.setCurrentPostSlide(newSlideIndex);
                                  return;
                                }
                                
                                // CRITICAL: Update ref immediately so event handlers have latest value
                                this.currentPostSlideRef.current = newSlideIndex;
                                
                                // Aggressively pause all videos in this post first
                                const postFiles = currentPost.attributes.files || [];
                                postFiles.forEach((file: any, fileIdx: number) => {
                                  if (file.link_content_type?.includes("video")) {
                                    // Try both key formats
                                    const videoKey1 = `post-${currentPost.id}-${fileIdx}`;
                                    const videoKey2 = fileIdx === 0 ? `post-${currentPost.id}` : null;
                                    
                                    [videoKey1, videoKey2].forEach((key) => {
                                      if (key) {
                                        const video = this.reelVideoRefs.get(key);
                                        if (video && !video.paused) {
                                          video.pause();
                                        }
                                        if (video) {
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }
                                    });
                                  }
                                });
                                
                                // Small delay to ensure previous video is paused
                                setTimeout(() => {
                                  // Only play if this is the current post being viewed
                                  // On desktop, keep all videos muted - no sound
                                  if (postIdx === this.currentPostIndexRef.current) {
                                    // Play the active video but keep muted on desktop
                                    const activeFile = postFiles[newSlideIndex];
                                    if (activeFile && activeFile.link_content_type?.includes("video")) {
                                      const videoKey = postFiles.length > 1 
                                        ? `post-${currentPost.id}-${newSlideIndex}`
                                        : `post-${currentPost.id}`;
                                      const video = this.reelVideoRefs.get(videoKey);
                                      if (video) {
                                        // Keep muted on desktop - no sound
                                        video.muted = true;
                                        video.volume = 0;
                                        video.play().catch(err => console.log('Video play failed:', err));
                                      }
                                    }
                                  }
                                }, 50);
                                
                                this.setCurrentPostSlide(newSlideIndex);
                              }}
                              pagination={{
                                clickable: true,
                                el: `.swiper-pagination-${currentPost.id}`,
                              }}
                              observer={true}
                              observeParents={true}
                            >
                              {currentPost.attributes.files.map((file: any, fileIdx: number) => (
                                <SwiperSlide key={fileIdx} style={{ height: '100%', width: '100%' }}>
                                  {file.link_content_type?.includes("image") ? (
                                    <img
                                      ref={(el) => {
                                        if (el) {
                                          const imageKey = `post-${currentPost.id}-${fileIdx}`;
                                          if (!this.processedImagesRef.current.has(imageKey)) {
                                            this.handleImageLoad(el, imageKey);
                                          }
                                        }
                                      }}
                                      src={file.link}
                                      alt={`Post ${postIdx} - Slide ${fileIdx}`}
                                      style={{
                                        border: 'none',
                                        objectFit: (this.imageResizeModes.get(`post-${currentPost.id}-${fileIdx}`) ||
                                          (this.isMobile ? 'cover' : 'contain')) as 'cover' | 'contain' | 'fill' | 'none' | 'scale-down',
                                        width: '100%',
                                        height: '100%',
                                        outline: 'none',
                                        background: 'transparent',
                                      }}
                                    />
                                  ) : (
                                    <video
                                      ref={(el) => {
                                        if (el) {
                                          const videoKey = `post-${currentPost.id}-${fileIdx}`;
                                          // Store video with both keys for consistency
                                          this.reelVideoRefs.set(videoKey, el);
                                          // Also store with post-${currentPost.id} key if it's the first video
                                          if (fileIdx === 0) {
                                            this.reelVideoRefs.set(`post-${currentPost.id}`, el);
                                          }
                                          if (!this.processedVideosRef.current.has(videoKey)) {
                                            this.handleVideoLoad(el, videoKey);
                                          }
                                          // Ensure video is muted and paused initially
                                          // Use refs to get latest values (not stale closures)
                                          const currentIdx = this.currentPostIndexRef.current;
                                          const currentSlide = this.currentPostSlideRef.current;
                                          const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                          if (!shouldPlay) {
                                            el.pause();
                                            el.muted = true;
                                            el.volume = 0;
                                          }
                                        }
                                      }}
                                      src={file.link}
                                      controls={false}
                                      loop
                                      muted={true}
                                      playsInline
                                      onPlay={(e) => {
                                        // Prevent video from playing if it's not the current active video
                                        // Use refs to get latest values (not stale closures)
                                        const video = e.currentTarget;
                                        const currentIdx = this.currentPostIndexRef.current;
                                        const currentSlide = this.currentPostSlideRef.current;
                                        const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                        if (!shouldPlay) {
                                          video.pause();
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }}
                                      onLoadedMetadata={(e) => {
                                        // Ensure video is muted and paused on load
                                        // Use refs to get latest values (not stale closures)
                                        const video = e.currentTarget;
                                        const currentIdx = this.currentPostIndexRef.current;
                                        const currentSlide = this.currentPostSlideRef.current;
                                        const shouldPlay = postIdx === currentIdx && fileIdx === currentSlide;
                                        if (!shouldPlay) {
                                          video.pause();
                                          video.muted = true;
                                          video.volume = 0;
                                        }
                                      }}
                                      style={{
                                        border: 'none',
                                        objectFit: (this.videoResizeModes.get(`post-${currentPost.id}-${fileIdx}`) ||
                                          (this.isMobile ? 'cover' : 'contain')) as 'cover' | 'contain' | 'fill' | 'none' | 'scale-down',
                                        width: '100%',
                                        height: '100%',
                                        outline: 'none',
                                        background: 'transparent',
                                      }}
                                    />
                                  )}
                                </SwiperSlide>
                              ))}
                            </Swiper>

                            {/* Instagram-like Dots */}
                            <div
                              className={`swiper-pagination-${currentPost.id}`}
                              style={{
                                position: 'absolute',
                                bottom: '12px',
                                left: 0,
                                right: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '6px',
                                zIndex: 10,
                              }}
                            ></div>
                          </>
                        ) : (
                          currentPost.attributes.files.map((file: any, fileIdx: number) => (
                            <Box
                              key={fileIdx}
                              style={{
                                position: 'absolute',
                                height: '100%',
                                width: '100%',
                                display: 'block',
                              }}
                            >
                              {file.link_content_type?.includes("image") ? (
                                <img
                                  ref={(el) => {
                                    if (el) {
                                      const imageKey = `post-${currentPost.id}-${fileIdx}`;
                                      if (!this.processedImagesRef.current.has(imageKey)) {
                                        this.handleImageLoad(el, imageKey);
                                      }
                                    }
                                  }}
                                  src={file.link}
                                  alt={`Post ${postIdx} - Slide ${fileIdx}`}
                                  style={{
                                    border: 'none',
                                    objectFit: (this.imageResizeModes.get(`post-${currentPost.id}-${fileIdx}`) ||
                                      (this.isMobile ? 'cover' : 'contain')) as 'cover' | 'contain' | 'fill' | 'none' | 'scale-down',
                                    width: '100%',
                                    height: '100%',
                                    outline: 'none',
                                    background: 'transparent',
                                  }}
                                />
                              ) : (
                                <video
                                  ref={(el) => {
                                    if (el) {
                                      const videoKey = `post-${currentPost.id}-${fileIdx}`;
                                      // Store video with both keys for consistency
                                      this.reelVideoRefs.set(`post-${currentPost.id}`, el);
                                      this.reelVideoRefs.set(videoKey, el);
                                      if (!this.processedVideosRef.current.has(videoKey)) {
                                        this.handleVideoLoad(el, videoKey);
                                      }
                                      // Ensure video is muted and paused initially
                                      // On desktop, always keep muted - no sound
                                      // Use refs to get latest values (not stale closures)
                                      const currentIdx = this.currentPostIndexRef.current;
                                      const shouldPlay = postIdx === currentIdx;
                                      if (!shouldPlay) {
                                        el.pause();
                                        el.muted = true;
                                        el.volume = 0;
                                      } else {
                                        // Even if should play, keep muted on desktop
                                        if (!this.isMobile) {
                                          el.muted = true;
                                          el.volume = 0;
                                        }
                                      }
                                    }
                                  }}
                                  src={file.link}
                                  controls={false}
                                  loop
                                  muted={true}
                                  playsInline
                                  onPlay={(e) => {
                                    // Prevent video from playing if it's not the current active video
                                    // Use refs to get latest values (not stale closures)
                                    const video = e.currentTarget;
                                    const currentIdx = this.currentPostIndexRef.current;
                                    const shouldPlay = postIdx === currentIdx;
                                    if (!shouldPlay) {
                                      video.pause();
                                      video.muted = true;
                                      video.volume = 0;
                                    } else {
                                      // On desktop, always keep muted - no sound
                                      if (!this.isMobile) {
                                        video.muted = true;
                                        video.volume = 0;
                                      }
                                    }
                                  }}
                                  onLoadedMetadata={(e) => {
                                    // Ensure video is muted and paused on load
                                    // On desktop, always keep muted - no sound
                                    // Use refs to get latest values (not stale closures)
                                    const video = e.currentTarget;
                                    const currentIdx = this.currentPostIndexRef.current;
                                    const shouldPlay = postIdx === currentIdx;
                                    if (!shouldPlay) {
                                      video.pause();
                                      video.muted = true;
                                      video.volume = 0;
                                    } else {
                                      // Even if should play, keep muted on desktop
                                      if (!this.isMobile) {
                                        video.muted = true;
                                        video.volume = 0;
                                      }
                                    }
                                  }}
                                  style={{
                                    border: 'none',
                                    objectFit: (this.videoResizeModes.get(`post-${currentPost.id}-${fileIdx}`) ||
                                      (this.isMobile ? 'cover' : 'contain')) as 'cover' | 'contain' | 'fill' | 'none' | 'scale-down',
                                    width: '100%',
                                    height: '100%',
                                    outline: 'none',
                                    background: 'transparent',
                                  }}
                                />
                              )}
                            </Box>
                          ))
                        )}
                      </Box>
                    )}

                    {/* Overlay Container - Unified parent for Poll and Action Bar (outside media Box) */}
                    {/* Instagram Reels: Overlay allows scroll events to pass through */}
                    <Box
                      style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 10, // Above media layer (1)
                        pointerEvents: 'none', // Instagram Reels: Allow scroll events to pass through
                      }}
                    >
                      {/* Display post poll as overlay on media (like Instagram stories) - Modal */}
                      {currentPost.attributes.poll && currentPost.attributes.poll.id && (
                        <Box 
                          style={{
                            position: 'absolute',
                            bottom: '115px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 12, // Poll layer - lower than action bar
                            width: 'fit-content', // Only as wide as content
                            maxWidth: '90%', // Constrain max width
                            pointerEvents: 'none', // Allow scroll events to pass through to reel
                            display: 'inline-flex', // Inline to prevent full-width expansion
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 'auto',
                          }}
                        >
                          {/* Only this inner box captures pointer events - the actual poll content */}
                          <Box 
                            style={{
                              pointerEvents: 'auto', // Poll content captures clicks
                              width: 'fit-content',
                              maxWidth: '400px',
                              position: 'relative',
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onTouchStart={(e) => e.stopPropagation()}
                          >
                            <Poll
                              poll={currentPost.attributes.poll}
                              poll_options={currentPost.attributes.poll_options || []}
                              accountProfile={currentPost.attributes.account_profile?.url}
                              handleVote={(optionId: number) => this.handleVote(optionId, currentPost.id)}
                              handleDeleteVote={(optionId: number) => this.handleDeleteVote(optionId, currentPost.id)}
                            />

                          </Box>
                        </Box>
                      )}

                      {/* Bottom Overlay - Action Bar */}
                      <Box 
                        className={this.props.classes.previewBottomWrapper}
                        style={{ pointerEvents: 'auto' }} // Action bar must capture clicks
                      >
                      <Box style={{ flex: 1, minWidth: 0, maxWidth: 'calc(100% - 80px)' }}>
                        <Typography
                          className="userName"
                          style={{ color: '#fff', marginBottom: '5px' }}
                        >
                          {currentPost.attributes.account?.first_name || 'User'}{' '}
                          {currentPost.attributes.account?.last_name || ''}
                        </Typography>
                        <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                          <Typography
                            variant="body2"
                            className={clsx(
                              this.props.classes.postDescripation,
                              expandedDescriptions.has(currentPost.id) &&
                              this.props.classes.postDescripationExpanded
                            )}
                            style={{
                              lineHeight: '1.4',
                              color: '#fff',
                            }}
                          >
                            {currentPost.attributes.body}
                          </Typography>
                          {currentPost.attributes.body &&
                            currentPost.attributes.body.length > 80 && (
                              <Typography
                                component="span"
                                variant="body2"
                                style={{
                                  cursor: 'pointer',
                                  fontWeight: 'bold',
                                  color: '#fff',
                                  marginLeft: '4px',
                                  textShadow: '0 1px 2px rgba(0,0,0,0.8)',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.setExpandedDescriptions((prev) => {
                                    const newSet = new Set(prev);
                                    if (newSet.has(currentPost.id)) newSet.delete(currentPost.id);
                                    else newSet.add(currentPost.id);
                                    return newSet;
                                  });
                                }}
                              >
                                {expandedDescriptions.has(currentPost.id) ? ' less' : ' more'}
                              </Typography>
                            )}
                        </Box>
                      </Box>

                      {/* Like/Comment Icons */}
                      <Box className={this.props.classes.reactionContainer}>
                        <Avatar
                          className={this.props.classes.avatar}
                          style={{
                            height: '35px',
                            width: '35px',
                            borderRadius: '40px',
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            this.handlePostProfileClick(currentPost.attributes.account_id);
                          }}
                        >
                          <img
                            src={currentPost.attributes.account_profile?.url || IconAvtar}
                            className={this.props.classes.fallbackAvatar}
                          />
                        </Avatar>

                        {(() => {
                          // Get is_liked value - check attributes first, then root level
                          // Also check if the value is explicitly false vs undefined/null
                          const isLikedValue = currentPost.attributes?.is_liked !== undefined 
                            ? currentPost.attributes.is_liked 
                            : (currentPost.is_liked !== undefined ? currentPost.is_liked : false);
                          
                          // Convert to boolean - handle true, "true", 1, "1", etc.
                          // Also handle false explicitly
                          const isLiked = isLikedValue === true || 
                                         isLikedValue === "true" || 
                                         isLikedValue === 1 || 
                                         isLikedValue === "1" ||
                                         (typeof isLikedValue === 'string' && isLikedValue.toLowerCase() === 'true');
                          
                          const likesCount = currentPost.attributes?.likes_count !== undefined
                            ? currentPost.attributes.likes_count
                            : (currentPost.likes_count !== undefined ? currentPost.likes_count : 0);
                          const commentsCount = currentPost.attributes?.comments_count !== undefined
                            ? currentPost.attributes.comments_count
                            : (currentPost.comments_count !== undefined ? currentPost.comments_count : 0);
                          
                          // Debug: Log for the current post being viewed
                          if (postIdx === currentPostIndex) {
                            console.log('Modal Post Like Status Check:', {
                              postId: currentPost.id,
                              isLikedValue: isLikedValue,
                              isLiked: isLiked,
                              likesCount: likesCount,
                              attributesIsLiked: currentPost.attributes?.is_liked,
                              fullAttributes: currentPost.attributes
                            });
                          }
                          
                          return (
                            <>
                              {isLiked ? (
                                <IconButton
                                  style={{ color: 'white', paddingBottom: 0 }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.handleUndoLikeAPICall(currentPost.id, 'Post');
                                  }}
                                >
                                  <FavoriteIcon style={{ color: 'red', fontSize: '30px' }} />
                                </IconButton>
                              ) : (
                                <IconButton
                                  style={{ color: 'white', paddingBottom: 0 }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.handleLikePostAPICall(currentPost, 'Post');
                                  }}
                                >
                                  <FavoriteBorderOutlinedIcon style={{ fontSize: '30px' }} />
                                </IconButton>
                              )}

                              <Typography
                                variant="body2"
                                style={{ color: '#fff', marginTop: '-6px' }}
                              >
                                {this.getValue(likesCount)}
                              </Typography>

                              <IconButton
                                onClick={(event) => this.openInstagramCommentModal(event, currentPost)}
                                style={{ padding: 0, marginTop: '7px' }}
                              >
                                <img
                                  src={CommentIconWhite}
                                  alt="Comment"
                                  className={this.props.classes.commentIconWhite}
                                />
                              </IconButton>

                              <Typography
                                variant="body2"
                                style={{ color: '#fff', marginTop: '-6px' }}
                              >
                                {this.getValue(commentsCount)}
                              </Typography>
                            </>
                          );
                        })()}

                        <IconButton
                          size="small"
                          onClick={this.handleClickPopOver}
                          className={this.props.classes.postSettingsBtn}
                        >
                          <MoreHorizRoundedIcon style={{ color: 'white', fontSize: '28px' }} />
                        </IconButton>
                      </Box>
                    </Box>
                    </Box>
                    {/* End Overlay Container */}
                  </Box>
                </SwiperSlide>
                );
              })}
            </Swiper>
          ) : null}
  <style>
    {`
      .swiper-pagination-bullet {
        background: grey;
        opacity: 1;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin: 0 3px;
        transition: all 0.3s ease;
      }

      .swiper-pagination-bullet-active {
        background: #FFC629 !important;
        width: 9px;
        height: 9px;
      }
    `}
  </style>
          {/* Comment Modal */}
          {this.isMobile && postPreviewComment ? (
            // Mobile: Bottom sheet style modal (like Instagram)
            <div 
              className="comment-modal-open"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: '64px',
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9999,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                overscrollBehavior: "contain",
                touchAction: "none"
              }}
              onClick={() => this.setPostPreviewComment(false)}
              onTouchStart={(e) => e.stopPropagation()}
              onTouchMove={(e) => e.stopPropagation()}
            >
              <div 
                style={{
                  width: "100%",
                  height: "60%",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(10px)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  borderRadius: "20px 20px 0 0",
                  transform: "translateY(0)",
                  transition: "transform 0.3s ease-out",
                  overscrollBehavior: "contain"
                }}
                onClick={(e) => e.stopPropagation()}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
              >
                {/* Header with close button */}
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "12px 20px 16px 20px",
                  backgroundColor: "transparent",
                  position: "relative"
                }}>
                  <div style={{
                    width: "40px",
                    height: "4px",
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    borderRadius: "2px",
                    margin: "0 auto 12px auto"
                  }}></div>
                  
                  <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <div style={{
                      color: "black",
                      fontSize: "18px",
                      fontWeight: "bold"
                    }}>
                      Comments
                    </div>
                  </div>
                  
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setPostPreviewComment(false);
                    }}
                    style={{
                      color: "black",
                      backgroundColor: "white",
                      border: "1px solid #ddd",
                      padding: "8px",
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontSize: "16px",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    ✕
                  </button>
                </div>
                
                {/* Comments List - Scrollable */}
                <div style={{
                  flex: 1,
                  overflowY: "auto",
                  overflowX: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "transparent",
                  padding: "0 20px",
                  maxHeight: "calc(60vh - 140px)",
                  minHeight: "200px",
                  WebkitOverflowScrolling: "touch",
                  overscrollBehavior: "contain",
                  scrollBehavior: "smooth",
                  touchAction: "auto"
                }}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
                onWheel={(e) => e.stopPropagation()}
                >
                  {this.getMobileCommentsUI()}
                </div>

                {/* Comment Input Section - Fixed at bottom */}
                {this.getMobileCommentInputUI()}
              </div>
              
              {/* Mobile Comment Options Popover */}
              {this.getMobileCommentPopover()}
            </div>
          ) : (
            // Desktop: Regular modal
            <Modal
              data-test-id="postPreviewCommentModal"
              open={postPreviewComment}
              onClose={() => this.setPostPreviewComment(!postPreviewComment)}
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box className={this.props.classes.postPreviewComments}>{this.getCommentsUI()}</Box>
            </Modal>
          )}
        </Box>
      </Modal>
              );
            })()}
        <div>
        <MobileNavEndUser navigation={navigation} />
      </div>
      </RootContainer>
    );
  }
  handleOpenPostModal = async (post: any) => {
    // Refresh user details to get the latest post data with all interactions
    // This ensures we have the most up-to-date likes, comments, and poll votes
    const userId = this.state.userID || this.props.navigation?.getParam?.('navigationBarTitleText');
    if (userId) {
      // Refresh the user details which includes posts with latest interaction data
      this.getEUProfileData(userId);
    }
    
    // Get all posts and sort them the same way as the profile page (trending first, then newest)
    const allPosts = this.state.postsDataEU || [];
    
    // Sort posts to match profile page order: trending first, then newest
    const sortedPosts = this.getSortedPostsForModal(allPosts);
    
    // Find the index in the sorted array
    const postIndex = sortedPosts.findIndex((p: any) => p.id === post.id);
    const latestPost = sortedPosts[postIndex] || post;
    
    this.setState({ 
      previewModalId: latestPost.id || post.id,
      selectedPost: latestPost,
      currentPostIndex: postIndex >= 0 ? postIndex : 0,
      currentPostSlide: 0,
    } as any);
  };
  
  // Helper method to sort posts the same way as profile page (trending first, then newest)
  getSortedPostsForModal = (posts: any[]) => {
    if (!posts || posts.length === 0) return [];
    
    // Helper function to fix date (same as in render)
    const fixDate = (d: any) => {
      if (!d) return null;
      
      if (typeof d === "string" && d.toLowerCase().includes("ago")) {
        const parts = d.toLowerCase().split(" ");
        const value = parseInt(parts[0]);
        const unit = parts[1];
        
        if (isNaN(value)) return null;
        
        const now = new Date();
        if (unit.startsWith("hour")) now.setHours(now.getHours() - value);
        else if (unit.startsWith("minute")) now.setMinutes(now.getMinutes() - value);
        else if (unit.startsWith("day")) now.setDate(now.getDate() - value);
        else return null;
        
        return now;
      }
      
      if (typeof d === "string" && d.includes(" ") && !d.includes("T")) {
        d = d.replace(" ", "T");
      }
      
      if (typeof d === "string" && /^\d{2}-\d{2}-\d{4}/.test(d)) {
        const [day, month, year] = d.split(/[-/]/);
        const rest = d.split(" ")[1] ?? "00:00:00";
        d = `${year}-${month}-${day}T${rest}`;
      }
      
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return null;
      return dt;
    };
    
    // 1) TOP 3 TRENDING (BY VIEWS) - same as profile page
    const trendingSorted = [...posts].sort((a, b) => {
      const viewsA = a.attributes?.views_count || 0;
      const viewsB = b.attributes?.views_count || 0;
      return viewsB - viewsA;
    });
    
    const trendingTop3 = trendingSorted.slice(0, 3);
    const trendingIds = new Set(trendingTop3.map((p) => p.id));
    
    // 2) OTHER POSTS – SORT BY NEWEST FIRST - same as profile page
    const regularPosts = posts
      .filter((p) => !trendingIds.has(p.id))
      .sort((a, b) => {
        const dateA = fixDate(a.attributes?.createdAt) || fixDate(a.attributes?.created_at);
        const dateB = fixDate(b.attributes?.createdAt) || fixDate(b.attributes?.created_at);
        return (dateB?.getTime() || 0) - (dateA?.getTime() || 0);
      });
    
    // Return: trending first, then regular posts (same order as profile page)
    return [...trendingTop3, ...regularPosts];
  };

  handlePreviewModalClose = () => {
    this.setState({ 
      previewModalId: null,
      selectedPost: null,
      currentPostIndex: 0,
      currentPostSlide: 0,
    } as any);
  };

  // Override receive to handle API responses for likes and votes
  async receive(from: string, message: Message) {
    // Call parent receive first
    await super.receive(from, message);
    
    const messageType = getName(MessageEnum.RestAPIResponceMessage);
    
    if (messageType === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      
      // Handle like/unlike API responses - refresh user details to get latest data
      if (apiRequestCallId === this.likePostApiCallId || apiRequestCallId === this.undoLikeApiCallId) {
        // Refresh user details to get the latest post data with updated likes
        const userId = this.state.userID || this.props.navigation?.getParam?.('navigationBarTitleText');
        if (userId) {
          this.getEUProfileData(userId);
        }
      }
      
      // Handle vote/delete vote API responses - refresh user details to get latest data
      if (apiRequestCallId === this.voteApiCallId || apiRequestCallId === this.deleteVoteApiCallId) {
        // Refresh user details to get the latest post data with updated poll votes
        const userId = this.state.userID || this.props.navigation?.getParam?.('navigationBarTitleText');
        if (userId) {
          this.getEUProfileData(userId);
        }
      }

      // Handle comment API responses
      if (apiRequestCallId === this.getCommentsApiCallId) {
        if (responseJson && responseJson.data) {
          this.comments = responseJson;
          this.forceUpdate();
        }
      }

      if (apiRequestCallId === this.postCommentApiCallId) {
        if (responseJson && !responseJson.errors) {
          // Refresh comments after posting
          const selectedPost = (this.state as any).selectedPost;
          const postId = selectedPost?.id || selectedPost?.attributes?.id;
          if (postId) {
            this.getPostCommentsApiCall(postId);
          }
          // Refresh user details to update comment count
          const userId = this.state.userID || this.props.navigation?.getParam?.('navigationBarTitleText');
          if (userId) {
            this.getEUProfileData(userId);
          }
        }
      }

      if (apiRequestCallId === this.deleteCommentApiCallId) {
        if (responseJson && !responseJson.errors) {
          // Refresh comments after deleting
          const selectedPost = (this.state as any).selectedPost;
          const postId = selectedPost?.id || selectedPost?.attributes?.id;
          if (postId) {
            this.getPostCommentsApiCall(postId);
          }
          // Refresh user details to update comment count
          const userId = this.state.userID || this.props.navigation?.getParam?.('navigationBarTitleText');
          if (userId) {
            this.getEUProfileData(userId);
          }
        }
      }

      if (apiRequestCallId === this.archiveCommentApiCallId || apiRequestCallId === this.revertArchiveCommentApiCallId) {
        if (responseJson && !responseJson.errors) {
          // Refresh comments after archive/revert
          const selectedPost = (this.state as any).selectedPost;
          const postId = selectedPost?.id || selectedPost?.attributes?.id;
          if (postId) {
            this.getPostCommentsApiCall(postId);
          }
        }
      }
      
      // When user details are refreshed, update the selected post in modal if it's open
      if (apiRequestCallId === this.euProfileApiCallId && (this.state as any).previewModalId) {
        const allPosts = responseJson?.data?.posts?.data || [];
        const previewModalId = (this.state as any).previewModalId;
        
        // Sort posts to match profile page order: trending first, then newest
        const sortedPosts = this.getSortedPostsForModal(allPosts);
        const updatedPost = sortedPosts.find((p: any) => p.id === previewModalId);
        
        if (updatedPost) {
          // Recalculate the post index in the sorted array
          const newPostIndex = sortedPosts.findIndex((p: any) => p.id === previewModalId);
          
          // Update the selected post with fresh data and maintain the current index
          this.setState({
            selectedPost: updatedPost,
            currentPostIndex: newPostIndex >= 0 ? newPostIndex : (this.state as any).currentPostIndex,
          } as any);
        }
      }
    }
  }

  setSwiperInstance = (swiper: SwiperCore | null) => {
    this.setState({ swiperInstance: swiper } as any);
  };

  setCurrentPostIndex = (index: number) => {
    this.currentPostIndexRef.current = index;
    this.setState({ currentPostIndex: index } as any);
  };

  setCurrentPostSlide = (slide: number) => {
    this.currentPostSlideRef.current = slide;
    this.setState({ currentPostSlide: slide } as any);
  };

  setExpandedDescriptions = (callback: (prev: Set<string | number>) => Set<string | number>) => {
    this.setState((prevState: any) => ({
      expandedDescriptions: callback(prevState.expandedDescriptions || new Set())
    } as any));
  };

  setPostPreviewComment = (value: boolean) => {
    this.setState({ postPreviewComment: value } as any);
  };

  handleImageLoad = (img: HTMLImageElement, imageKey: string) => {
    if (this.processedImagesRef.current.has(imageKey)) return;
    this.processedImagesRef.current.add(imageKey);
    
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const aspectRatio = naturalWidth / naturalHeight;
    
    // Determine resize mode based on aspect ratio
    const resizeMode = aspectRatio > 1 ? 'contain' : 'cover';
    this.imageResizeModes.set(imageKey, resizeMode);
  };

  handleVideoLoad = (video: HTMLVideoElement, videoKey: string) => {
    if (this.processedVideosRef.current.has(videoKey)) return;
    this.processedVideosRef.current.add(videoKey);
    
    video.addEventListener('loadedmetadata', () => {
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      const aspectRatio = videoWidth / videoHeight;
      
      // Determine resize mode based on aspect ratio
      const resizeMode = aspectRatio > 1 ? 'contain' : 'cover';
      this.videoResizeModes.set(videoKey, resizeMode);
    });
  };

  getValue = (num: any) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return num;
  };

  // Comment-related instance variables
  comments: any = null;
  comment: string = "";
  replyingToID: string | null = null;
  replyingToName: string = "";
  selectedCommentId: string | null = null;
  selectedComment: any = null;
  viewReplies: string | null = null;
  anchorEl: any = null;
  commentImage: File | null = null;
  isSortingComments: boolean = false;
  highlightedComment: string | null = null;
  archivedStatus: { [key: string]: boolean } = {};
  commentRef: React.RefObject<HTMLInputElement> = React.createRef();
  imageInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  getCommentsApiCallId: string = "";
  postCommentApiCallId: string = "";
  deleteCommentApiCallId: string = "";
  archiveCommentApiCallId: string = "";
  revertArchiveCommentApiCallId: string = "";
  likeCommentApiCallId: string = "";
  undoLikeCommentApiCallId: string = "";

  openInstagramCommentModal = (event: any, post: any) => {
    event.stopPropagation();
    const postId = post.id || post.attributes?.id;
    if (postId) {
      // Set the selected post for comments
      this.setState({ selectedPost: post } as any);
      this.getPostCommentsApiCall(postId);
      this.setPostPreviewComment(true);
    }
  };

  handleCommentClose = () => {
    this.setPostPreviewComment(false);
    this.comment = "";
    this.replyingToID = null;
    this.replyingToName = "";
    this.viewReplies = null;
    this.commentImage = null;
    this.comments = null;
    this.forceUpdate();
  };

  getPostCommentsApiCall = (postId: string) => {
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    if (!token) return;

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getCommentsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${dashboardConfigJSON.postCommentEndPoint}?commentable_id=${postId}&commentable_type=${dashboardConfigJSON.PostClass}&sort=desc`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.dashboarApiMethodType
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  postCommentApiCall = (formData: FormData, postId?: string) => {
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    if (!token) return;

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.postCommentApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      dashboardConfigJSON.postCommentEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpPostMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  deleteCommentApiCall = (commentId: string, postId: string) => {
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    if (!token) return;

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.deleteCommentApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${dashboardConfigJSON.postCommentEndPoint}/${commentId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpDelMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  archiveCommentApiCall = (values: any) => {
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    if (!token) return;

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.archiveCommentApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      dashboardConfigJSON.archiveCommentEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpPostMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(values)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  revertArchiveCommentApiCall = (values: any) => {
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    if (!token) return;

    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.revertArchiveCommentApiCallId = requestMessage.messageId;

    // Revert archive uses DELETE method on the archive endpoint
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      dashboardConfigJSON.archiveCommentEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpDelMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(values)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.anchorEl = event.currentTarget;
    this.forceUpdate();
  };

  handleClose = () => {
    this.anchorEl = null;
    this.forceUpdate();
  };

  handleCommentClick = (accountId: number) => {
    // Handle comment click logic
  };

  handleReplyClick = (commentId: string, name: string) => {
    this.replyingToID = commentId;
    this.replyingToName = name;
    this.comment = "";
    this.forceUpdate();
    if (this.commentRef.current) {
      this.commentRef.current.focus();
    }
  };

  handleCommentToPost = () => {
    const postPreviewComment = (this.state as any).postPreviewComment;
    if (!postPreviewComment) return;

    const selectedPost = (this.state as any).selectedPost;
    const postId = selectedPost?.id || selectedPost?.attributes?.id;
    if (!postId) return;

    const formData = new FormData();
    formData.append('comment[commentable_id]', postId.toString());
    formData.append('comment[commentable_type]', dashboardConfigJSON.PostClass);
    formData.append('comment[comment]', this.comment || "");

    if (this.replyingToID) {
      formData.append('comment[parent_id]', this.replyingToID);
    }

    if (this.commentImage) {
      formData.append('comment[files][]', this.commentImage);
    }

    this.postCommentApiCall(formData, postId);
    this.comment = "";
    this.replyingToID = null;
    this.replyingToName = "";
    this.commentImage = null;
    this.forceUpdate();
  };

  handleImageCommentClick = () => {
    if (this.imageInputRef.current) {
      this.imageInputRef.current.click();
    }
  };

  handleImageCommentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      this.commentImage = file;
      this.forceUpdate();
    }
  };

  handleImageCommentRemove = () => {
    this.commentImage = null;
    this.forceUpdate();
  };

  handleCommentOnBlur = () => {
    // Handle comment blur if needed
  };

  handleClickPopOver = () => {
    // Handle popover click
  };

  getCommentsUI = () => {
    const { classes } = this.props;
    const comments = this.comments;
    const isMobile = this.isMobile;
    const postPreviewComment = (this.state as any).postPreviewComment;
    const selectedPost = (this.state as any).selectedPost;
    const account_id = selectedPost?.attributes?.account_id || selectedPost?.account_id;

    if (!postPreviewComment || !selectedPost) {
      return <Box>Loading...</Box>;
    }

    const commonFunctionForCondition = (condition: any, trueValue: any, falseValue: any) => {
      return condition ? trueValue : falseValue;
    };

    const StyledMenuItem = withStyles((theme: Theme) =>
      createStyles({
        root: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      })
    )(MenuItem);

    const ReceiverMessageContainer = styled("div")({
      display: "flex",
      justifyContent: "flex-start",
      padding: "0px",
      width: "94%",
      marginRight: "auto",
      "@media (max-width: 480px)": {
        padding: "0 0 10px 0"
      },
      "& .commenterTime": {
        fontSize: "12px",
        marginLeft:'10px'
      }
    });

    const MessageBubble = styled(Paper)({
      padding: "0px 16px 12px 0px",
      borderRadius: "0px 16px 16px 16px",
      background: "transparent",
      boxShadow: "none",
      "@media (max-width: 950px)": {
        padding: "12px"
      },
      "& .replyToCommentTime": {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Inter",
        fontStyle: "normal",
        color: "#64748B",
        "@media (max-width: 950px)": {
          fontSize: "12px"
        }
      }
    });

    const ReplayToComment = styled(Box)({
      display: "flex",
      paddingLeft: "67px",
      "@media (max-width: 950px)": {
        paddingLeft: "48px"
      }
    });

    const getCommentHeaderUI = (item: any, isCurrentUserPost: boolean = false) => {
      const isNotCurrentUser = !isCurrentUserPost;
      let backgroundColor = "transparent";
      let borderRadius = "0px";
      let padding = "0px";
      let margin = "0px";

      if (isNotCurrentUser) {
        backgroundColor = "#fff2d2";
        padding = "8px";
      }

      return (
        <div
          className={classes.commentscardHeader}
          style={{
            backgroundColor: backgroundColor,
            borderRadius: borderRadius,
            padding: padding,
            margin: margin,
            transition: "all 0.3s ease-in-out"
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
            id="commentAvtarBox"
          >
            <Avatar
              className={classes.avatar}
              data-test-id="commentAvtarBox"
            >
              <img
                src={commonFunctionForCondition(
                  item.attributes?.account.data?.attributes
                    ?.profile_pic?.url,
                  item.attributes?.account.data?.attributes
                    ?.profile_pic?.url,
                  IconAvtar
                )}
                className={`${classes.fallbackAvatar} ${
                  item.attributes?.archived == null
                    ? classes.cardHeaderContentOfResponsiveContainer
                    : ""
                }`}
                onError={(e) => {
                  // If image fails to load, show fallback avatar
                  const target = e.target as HTMLImageElement;
                  if (target.src !== IconAvtar) {
                    target.src = IconAvtar;
                  }
                }}
              />
            </Avatar>
          </Box>
          <div
            className={`${classes.cardHeaderContent} ${
              item.attributes?.archived == null
                ? classes.cardHeaderContentOfResponsiveContainer
                : ""
            }`}
            id="commentcardHeader"
          >
            <ReceiverMessageContainer id="commentContainer">
              <MessageBubble data-test-id="commentBuble">
                <div
                  style={{
                    display: "flex",
                    // justifyContent: "space-between",
                  }}
                >
                  <div className="commenterNAme">
                    <Typography
                      className={classes.commnetSectionUser}
                    >
                      {commonFunctionForCondition(
                        item.attributes?.account.data.attributes
                          .first_name !== null,
                        item.attributes?.account.data.attributes
                          .first_name,
                        ""
                      ) +
                        " " +
                        commonFunctionForCondition(
                          item.attributes?.account.data.attributes
                            .last_name !== null,
                          item.attributes?.account.data.attributes
                            .last_name,
                          ""
                        )}
                    </Typography>
                  </div>
                  <div className="commenterTime">
                    <Typography className={classes.commentTime}>
                      {moment(
                        item.attributes?.created_at
                      ).fromNow()}
                    </Typography>
                  </div>
                </div>
                <Typography className={classes.commentFonts}>
                  {item.attributes.comment}
                </Typography>
                <CommentImage files={item.attributes.files} />
              </MessageBubble>
            </ReceiverMessageContainer>
          </div>
          <div className={classes.commentCardHeaderAction} data-test-id="postSettingsIcon">
            <IconButton
              size="small"
              onClick={(event: any) => {
                this.handleClick(event);
                this.handleCommentClick(item.attributes?.account_id);
                this.replyingToName = commonFunctionForCondition(
                  item.attributes?.account?.data?.attributes?.first_name !== null,
                  item.attributes?.account?.data?.attributes?.first_name,
                  ""
                ) + " " + commonFunctionForCondition(
                  item.attributes?.account?.data?.attributes?.last_name !== null,
                  item.attributes?.account?.data?.attributes?.last_name,
                  ""
                );
                this.selectedCommentId = item.attributes?.id;
                this.selectedComment = item;
              }}
              aria-label="post-settings"
              className={classes.postSettingsBtn}
              data-test-id="threeDotIconPopOver"
            >
              <MoreVertIcon data-test-id="commentMore" />
            </IconButton>
          </div>
        </div>
      );
    };

    const getCommentActionsUI = (item: any, isCurrentUserPost: boolean = false) => {
      const isNotCurrentUser = !isCurrentUserPost;
      
      return (
        <div
          className={`${classes.commentCardActions} ${
            item.attributes?.archived == null
              ? classes.cardHeaderContentOfResponsiveContainer
              : ""
          }`}
          id="cardActions"
          style={{
            backgroundColor: isNotCurrentUser ? "#fff2d2" : "transparent",
            // borderRadius: isNotCurrentUser ? "8px" : "0px",
            // padding: isNotCurrentUser ? "8px" : "0px",
            // margin: isNotCurrentUser ? "0px 0px 20px 0px" : "0px 0px 20px 0px",
            transition: "all 0.3s ease-in-out"
          }}
        >
          <div
            className={classes.reactionBtn}
            data-test-id="reactionButtons"
          >
            {item.attributes?.already_liked ? (
              <IconButton data-test-id="undo-like-comment" className="icons" aria-label="post-likes" onClick={() => this.handleUndoLikeAPICall(item.id, "Comment", selectedPost?.id)} style={{padding:'0px'}}>
                <img src={redHeart} alt="heart" className="likes" />
              </IconButton>
            ) : (
              <IconButton
                onClick={() =>
                  this.handleLikePostAPICall(item, "Comment")
                }
                className="icons"
                aria-label="post-likes"
              >
                <img
                  src={HeartSmallIcon}
                  alt="heart"
                  className="likes"
                />
              </IconButton>
            )}
            <Typography
              variant="body2"
              data-test-id="likesCountss"
              className={classes.likesComments}
              component="span"
            >
              {item.attributes?.likes_count}
            </Typography>
          </div>
          <div
            className={classes.reactionBtn}
            data-test-id="replyOuter"
            onClick={() =>
              this.handleReplyClick(
                item.id,
                commonFunctionForCondition(
                  item.attributes?.account.data.attributes
                    .first_name !== null,
                  item.attributes?.account.data.attributes
                    .first_name,
                  ""
                ) +
                  " " +
                  commonFunctionForCondition(
                    item.attributes?.account.data.attributes
                      .last_name !== null,
                    item.attributes?.account.data.attributes
                      .last_name,
                    ""
                  )
              )
            }
            id="cardChatButtons"
          >
            <Typography
              variant="body2"
              className={classes.likesComments}
              style={{ cursor: "pointer" }}
              component="span"
              id="chatBubbleCounts"
            >
              Reply
            </Typography>
          </div>
          {handleOrConditions(
            item.attributes?.replies?.data.length,
            <div
              className={classes.reactionBtn}
              data-test-id="openRepliesButton"
              onClick={() => {
                if (this.viewReplies === item.id) {
                  this.viewReplies = null;
                } else {
                  this.viewReplies = item.id;
                }
                this.forceUpdate();
              }}
            >
              <Typography
                component="span"
                variant="body2"
                className={classes.viewComments}
              >
                View reply
              </Typography>

              <IconButton size="small" className={clsx(classes.replyExpandIcon, {
                [classes.replyExpandedIcon]: this.viewReplies === item.id
              })} aria-label="post-likes">
                <ExpandMoreIcon />
              </IconButton>
            </div>,
            null
          )}
        </div>
      );
    };

    const getCommentsListUI = () => {
      if (!comments?.data || comments.data.length === 0) {
        return (
          <Box style={{ textAlign: 'center', padding: '20px 20px', color: '#666', fontSize: '16px' }}>
            <Typography variant="body1" style={{ color: '#999', fontSize: '14px' }}>
              No comments yet
            </Typography>
            <Typography variant="body2" style={{ color: '#ccc', fontSize: '12px', marginTop: '8px' }}>
              Be the first to comment!
            </Typography>
          </Box>
        );
      }

      return (
        <Box>
          {comments.data.map((item: any) => {
            const isCurrentUserPost = item?.attributes?.account_id == account_id;
            return (
              <div key={item.id} id={`comment-${item.id}`}>
                {getCommentHeaderUI(item, isCurrentUserPost)}
                {getCommentActionsUI(item, isCurrentUserPost)}

                {this.viewReplies === item.id && item.attributes?.replies?.data?.map((replyItem: any) => {
                  if (!replyItem || !replyItem.attributes) return null;
                  const { attributes, attributes: { account, files } } = replyItem;
                  const { data: { attributes: { first_name, last_name } } } = account;

                  const isReplyCurrentUserPost = replyItem?.attributes?.account_id == account_id;
                  const isReplyNotCurrentUser = !isReplyCurrentUserPost;

                  let replyBackgroundColor = "transparent";
                  let replyBorderRadius = "0px";
                  let replyPadding = "0px";
                  let replyMargin = "0px";

                  if (isReplyNotCurrentUser) {
                    replyBackgroundColor = "#fff2d2";
                    replyBorderRadius = "8px";
                    replyPadding = "8px";
                    replyMargin = "4px 0";
                  }

                  return (
                    <>
                      <div>
                        <ReplayToComment 
                          className={classes.commentscardHeader}
                          style={{
                            backgroundColor: replyBackgroundColor,
                            borderRadius: replyBorderRadius,
                            padding: replyPadding,
                            margin: replyMargin,
                            transition: "all 0.3s ease-in-out"
                          }}
                        >
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Avatar className={classes.avatar}>
                              <img
                                src={commonFunctionForCondition(
                                  replyItem.attributes?.account.data.attributes
                                    ?.profile_pic?.url,
                                  replyItem.attributes?.account.data.attributes
                                    ?.profile_pic?.url,
                                  IconAvtar
                                )}
                                className={classes.fallbackAvatar}
                              />
                            </Avatar>
                          </Box>
                          <div
                            className={`${classes.cardHeaderContent} ${
                              replyItem.attributes?.archived == null
                                ? classes.cardHeaderContentOfResponsiveContainer
                                : ""
                            }`}
                          >
                            <ReceiverMessageContainer>
                              <MessageBubble>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ marginRight: "10px" }}>
                                    <Typography
                                      className={
                                        classes.commnetSectionUser
                                      }
                                    >
                                      {replyItem.attributes?.account.data
                                        .attributes?.first_name +
                                        " " +
                                        replyItem.attributes?.account.data
                                          .attributes?.last_name}
                                    </Typography>
                                  </div>
                                  <div>
                                    <Typography className="replyToCommentTime" >
                                      {moment(
                                        replyItem.attributes?.created_at
                                      ).fromNow()}
                                    </Typography>
                                  </div>
                                </div>
                                <Typography
                                  className={classes.commentFonts}
                                >
                                  {replyItem.attributes?.comment}
                                </Typography>
                                <CommentImage files={files} />
                              </MessageBubble>
                            </ReceiverMessageContainer>
                          </div>

                          <div
                            className={classes.commentCardHeaderAction}
                            data-test-id="replyCommentDivv"
                          >
                            <IconButton
                              size="small"
                              onClick={(event: any) => {
                                this.handleClick(event);
                                this.selectedComment = replyItem;
                                this.handleCommentClick(
                                  replyItem.attributes?.account_id
                                );
                                this.replyingToName = `${first_name} ${last_name}`;
                                this.selectedCommentId = replyItem.id;
                              }}
                              aria-label="post-settings"
                              className={classes.postSettingsBtn}
                              data-test-id="replyCommenthreeDotPopOver"
                            >
                              <MoreVertIcon data-test-id="commentMore" />
                            </IconButton>
                          </div>
                        </ReplayToComment>
                        </div>
                        <div
                          data-test-id="replyCOmmentActions"
                          className={`${classes.commentReplyCardActions} ${
                            replyItem.attributes?.archived == null
                              ? classes.cardHeaderContentOfResponsiveContainer
                              : ""
                          }`}
                          style={{
                            backgroundColor: isReplyNotCurrentUser ? "#fff2d2" : "transparent",
                            // borderRadius: isReplyNotCurrentUser ? "8px" : "0px",
                            padding: isReplyNotCurrentUser ? "8px" : "0px",
                            // margin: isReplyNotCurrentUser ? "0px 0px 10px 0px" : "0px 0px 10px 0px",
                            transition: "all 0.3s ease-in-out"
                          }}
                        >
                          <div
                            className={classes.reactionBtn}
                            data-test-id="reactonButtonsOfReply"
                          >
                            <IconButton aria-label="post-likes" onClick={() => this.handleReplyLike(replyItem, item.id)} style={{padding:'0px'}}>
                              <img src={attributes.already_liked ? redHeart :HeartSmallIcon} />
                            </IconButton>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.likesComments}
                            >
                              {attributes.likes_count}
                            </Typography>
                          </div>
                          <div className={classes.reactionBtn}>
                            <div
                              className={classes.reactionBtn}
                              data-test-id="replyOuter"
                              onClick={() =>
                                this.handleReplyClick(
                                  item.id,
                                  `${first_name} ${last_name}`
                                )
                              }
                              id="cardChatButtons"
                            >
                              <Typography
                                variant="body2"
                                className={classes.likesComments}
                                style={{ cursor: "pointer" }}
                                component="span"
                                id="chatBubbleCounts"
                              >
                                Reply
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                })}
              </div>
            );
          })}
        </Box>
      );
    };

    const openCommentPopover = Boolean(this.anchorEl);
    const commentId = openCommentPopover ? "simple-popover" : "";

    return (
      <div className={classes.commentSectionContainer}>
        <CustomLoader isLoading={this.isSortingComments} wrapperHeight="150px" loaderSize={20}>
          {((comments && comments.data && comments.data.length > 0)) ? (
            <Box className={classes.commentsContentWrapper} style={!isMobile ? { maxHeight: '260px' } : {}}>
              <Divider />
              <Box className={classes.commentCloseIconWrapper}>
                <IconButton onClick={this.handleCommentClose}>
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box className={classes.pollCommentsWrapper}>
                {getCommentsListUI()}
              </Box>
              <Popover
                id={commentId}
                open={openCommentPopover}
                anchorEl={this.anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "right",
                }}
                classes={{
                  paper: classes.popOverPaper,
                }}
              >
                <StyledMenuItem
                  data-test-id="reply"
                  onClick={() => {
                    this.handleClose();
                    if (this.selectedCommentId) {
                      this.handleReplyClick(this.selectedCommentId, this.replyingToName);
                    }
                  }}
                >
                  <ListItemText primary="Reply" />
                </StyledMenuItem>
                <CustomConditionalRender isRender={account_id === parseInt(localStorage.getItem('userId') || '0')}>
                  <>
                    <StyledMenuItem
                      data-test-id="archive"
                      disabled={
                        this.selectedCommentId === null ||
                        this.archivedStatus[this.selectedCommentId || '']
                      }
                      onClick={() => {
                        const values = {
                          archives: {
                            archiveable_id: this.selectedCommentId,
                            archiveable_type: "BxBlockComments::Comment",
                          },
                        };
                        this.archiveCommentApiCall(values);
                        if (this.selectedCommentId) {
                          this.archivedStatus[this.selectedCommentId] = true;
                        }
                        this.handleClose();
                      }}
                    >
                      <ListItemText primary="Archive" />
                    </StyledMenuItem>
                    <StyledMenuItem
                      data-test-id="revertArchive"
                      disabled={
                        Boolean(this.selectedCommentId && !this.archivedStatus[this.selectedCommentId || ''])
                      }
                      onClick={() => {
                        const values = {
                          archives: {
                            archiveable_id: this.selectedCommentId,
                            archiveable_type: "BxBlockComments::Comment",
                          },
                        };
                        this.revertArchiveCommentApiCall(values);
                        if (this.selectedCommentId) {
                          this.archivedStatus[this.selectedCommentId] = false;
                        }
                        this.handleClose();
                      }}
                    >
                      <ListItemText primary="Revert archive" />
                    </StyledMenuItem>
                  </>
                </CustomConditionalRender>
                <CustomConditionalRender isRender={this.selectedComment?.attributes?.account_id === parseInt(localStorage.getItem('userId') || '0')}>
                  <StyledMenuItem
                    data-test-id="delete"
                    onClick={() => {
                      const postId = selectedPost?.id || selectedPost?.attributes?.id;
                      if (this.selectedCommentId && postId) {
                        this.deleteCommentApiCall(this.selectedCommentId, postId);
                      }
                      this.handleClose();
                    }}
                  >
                    <ListItemText primary="Delete" />
                  </StyledMenuItem>
                </CustomConditionalRender>
                <CustomConditionalRender isRender={this.selectedComment?.attributes?.account_id !== parseInt(localStorage.getItem('userId') || '0')}>
                  <StyledMenuItem data-test-id="banUserOfComment">
                    <ListItemText primary="Ban user" />
                  </StyledMenuItem>
                </CustomConditionalRender>
              </Popover>
            </Box>
          ) : (
            <Box className={classes.commentsContentWrapper}>
              <Divider />
              <Box className={classes.commentCloseIconWrapper}>
                <IconButton onClick={this.handleCommentClose}>
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box className={classes.pollCommentsWrapper}>
                <Box style={{ textAlign: 'center', padding: '20px 20px', color: '#666', fontSize: '16px' }}>
                  <Typography variant="body1" style={{ color: '#999', fontSize: '14px' }}>
                    No comments yet
                  </Typography>
                  <Typography variant="body2" style={{ color: '#ccc', fontSize: '12px', marginTop: '8px' }}>
                    Be the first to comment!
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </CustomLoader>
        <Box style={{
          flexShrink: 0,
          padding: '12px 16px',
          borderTop: '1px solid #E2E8F0',
          backgroundColor: '#fff'
        }}>
          {this.commentImage && (
            <Box paddingX={1} style={{ marginBottom: '8px' }}>
              <Box className={classes.commentImagePreviewWrapper}>
                <IconButton
                  size="small"
                  data-test-id="image-comment-remove"
                  onClick={this.handleImageCommentRemove}
                >
                  <CloseRoundedIcon fontSize="small" />
                </IconButton>
                <img
                  src={URL.createObjectURL(this.commentImage)}
                  alt="Image"
                  data-test-id="comment-image-selected"
                  className={classes.commentImage}
                />
              </Box>
            </Box>
          )}
          <Box alignItems="center" className={classes.postCommentRoot} style={{ margin: 0, padding: 0 }}>
            <Box>
              <IconButton
                style={{ paddingLeft: "8px" }}
                data-test-id="image-comment-upload"
                aria-label="add emoji"
                onClick={this.handleImageCommentClick}
              >
                <img src={uploadIcon} alt="uploadIcon" />
                <input
                  ref={this.imageInputRef}
                  accept=".jpeg, .jpg, .png"
                  type="file"
                  hidden
                  data-test-id="image-comment-file"
                  capture={this.isMobile ? "environment" : undefined}
                  onChange={this.handleImageCommentUpload}
                />
              </IconButton>
            </Box>
            <Box className={classes.commentInputBox}>
              <Box>
                <TextField
                  data-test-id="commentField"
                  placeholder={this.replyingToID ? `Replying to ${this.replyingToName}` : "Add a Comment"}
                  inputRef={this.commentRef}
                  onBlur={this.handleCommentOnBlur}
                  variant="outlined"
                  value={this.comment || ""}
                  fullWidth
                  multiline
                  maxRows={6}
                  minRows={1}
                  name="comment"
                  onChange={(e: any) => {
                    this.comment = e.target.value;
                    this.forceUpdate();
                  }}
                  InputProps={{
                    classes: {
                      root: classes.postCommentTextField,
                      input: classes.postCommentinput,
                    },
                  }}
                  InputLabelProps={{
                    classes: {
                      root: classes.placeholder,
                    },
                  }}
                />
              </Box>
            </Box>
            <Box className={classes.uploadFileBox}></Box>
            <Box className={clsx("iconStyle", classes.postCommentBox)}>
              <IconButton
                size="small"
                disabled={Boolean(!this.comment && !this.commentImage)}
                data-test-id="postCommentApiCall"
                onClick={this.handleCommentToPost}
              >
                <img src={sendMedssageIcon} alt="sendIcon" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </div>
    );
  };

  getMobileCommentsUI = () => {
    const { classes } = this.props;
    const comments = this.comments;
    const selectedPost = (this.state as any).selectedPost;
    const account_id = selectedPost?.attributes?.account_id || selectedPost?.account_id;
    const viewReplies = this.viewReplies;

    const commonFunctionForCondition = (condition: any, trueValue: any, falseValue: any) => {
      return condition ? trueValue : falseValue;
    };

    if (!comments || !comments.data || comments.data.length === 0) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          color: "#666",
          textAlign: "center"
        }}>
          <div style={{
            fontSize: "16px",
            marginBottom: "8px",
            fontWeight: 500
          }}>
            No comments yet
          </div>
          <div style={{
            fontSize: "14px",
            color: "#999"
          }}>
            Be the first to comment!
          </div>
        </div>
      );
    }

    return (
      <div style={{ padding: "16px 0" }}>
        {comments.data.map((item: any, index: number) => {
          const isCurrentUserPost = item?.attributes?.account_id == account_id;
          const isNotCurrentUser = !isCurrentUserPost;
          
          // Determine background color: not current user (cream/beige) > transparent
          let backgroundColor = "transparent";
          if (isNotCurrentUser) {
            backgroundColor = "#fff2d2"; // Cream/beige color
          }
          
          return (
            <div key={item.id} style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              marginBottom: "16px",
              padding: "8px 0",
              backgroundColor: backgroundColor,
              borderRadius: "8px",
              transition: "background-color 200ms ease"
            }}>
              <Avatar style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#666",
                fontSize: "12px",
                flexShrink: 0
              }}>
                <img
                  src={commonFunctionForCondition(
                    item.attributes?.account.data.attributes?.profile_pic?.url,
                    item.attributes?.account.data.attributes?.profile_pic?.url,
                    IconAvtar
                  )}
                  className={classes.fallbackAvatar}
                />
              </Avatar>
              
              <div style={{ flex: 1 }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "4px"
                }}>
                  <span style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px"
                  }}>
                    {item.attributes?.account?.data?.attributes?.first_name || "User"} {item.attributes?.account?.data?.attributes?.last_name || ""}
                  </span>
                  <span style={{
                    color: "#666",
                    fontSize: "12px"
                  }}>
                    {moment(item.attributes?.created_at).fromNow()}
                  </span>
                </div>
                
                <div style={{
                  color: "black",
                  fontSize: "14px",
                  marginBottom: "8px",
                  lineHeight: "1.4"
                }}>
                  {item.attributes?.comment}
                </div>
                
                {item.attributes?.files && item.attributes.files.length > 0 && (
                  <CommentImage files={item.attributes.files} />
                )}
                
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  backgroundColor: isNotCurrentUser ? "#fff2d2" : "transparent",
                  transition: "all 0.3s ease-in-out"
                }}>
                  <div className={classes.reactionBtn} data-test-id="reactonButtonsOfComment">
                    <IconButton 
                      aria-label="post-likes" 
                      onClick={() => {
                        if (item.attributes?.already_liked) {
                          this.handleUndoLikeAPICall(item.id, "Comment", selectedPost?.id);
                        } else {
                          this.handleLikePostAPICall(item, "Comment");
                        }
                      }} 
                      style={{padding:'0px'}}
                    >
                      <img src={item.attributes?.already_liked ? redHeart : HeartSmallIcon} style={{padding:'0px'}} />
                    </IconButton>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.likesComments}
                    >
                      {item.attributes?.likes_count || 0}
                    </Typography>
                  </div>
                   
                  <button 
                    onClick={() => this.handleReplyClick(
                      item.id,
                      `${item.attributes?.account?.data?.attributes?.first_name || "User"} ${item.attributes?.account?.data?.attributes?.last_name || ""}`
                    )}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#666",
                      fontSize: "12px",
                      cursor: "pointer"
                    }}
                  >
                    Reply
                  </button>

                  {item.attributes?.replies?.data && item.attributes.replies.data.length > 0 && (
                    <button
                      onClick={() => {
                        if (this.viewReplies === item.id) {
                          this.viewReplies = null;
                        } else {
                          this.viewReplies = item.id;
                        }
                        this.forceUpdate();
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#666",
                        fontSize: "12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px"
                      }}
                    >
                      View reply
                      <span style={{ fontSize: "10px" }}>⌄</span>
                    </button>
                  )}
                </div>

                {/* Reply Comments */}
                {item.attributes?.replies?.data && item.attributes.replies.data.length > 0 && viewReplies === item.id && (
                  <div style={{
                    marginTop: "12px",
                    paddingLeft: "20px",
                    borderLeft: "2px solid #f0f0f0"
                  }}>
                    {item.attributes.replies.data.map((reply: any, replyIndex: number) => {
                      const isReplyCurrentUserPost = reply?.attributes?.account_id == account_id;
                      const isReplyNotCurrentUser = !isReplyCurrentUserPost;
                      
                      // Determine background color: not current user (cream/beige) > transparent
                      let replyBackgroundColor = "transparent";
                      if (isReplyNotCurrentUser) {
                        replyBackgroundColor = "#fff2d2"; // Cream/beige color
                      }
                      
                      return (
                        <div key={reply.id} style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "8px",
                          marginBottom: "8px",
                          padding: replyBackgroundColor !== "transparent" ? "8px" : "4px 0",
                          backgroundColor: replyBackgroundColor,
                          borderRadius: "8px"
                        }}>
                          <Avatar style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            backgroundColor: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#666",
                            fontSize: "10px",
                            flexShrink: 0
                          }}>
                            <img
                              src={commonFunctionForCondition(
                                reply.attributes?.account.data.attributes?.profile_pic?.url,
                                reply.attributes?.account.data.attributes?.profile_pic?.url,
                                IconAvtar
                              )}
                              className={classes.fallbackAvatar}
                            />
                          </Avatar>
                          
                          <div style={{ flex: 1 }}>
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              marginBottom: "2px"
                            }}>
                              <span style={{
                                color: "black",
                                fontWeight: "bold",
                                fontSize: "12px"
                              }}>
                                {reply.attributes?.account?.data?.attributes?.first_name || "User"} {reply.attributes?.account?.data?.attributes?.last_name || ""}
                              </span>
                              <span style={{
                                color: "#666",
                                fontSize: "10px"
                              }}>
                                {moment(reply.attributes?.created_at).fromNow()}
                              </span>
                            </div>
                            
                            <div style={{
                              color: "black",
                              fontSize: "12px",
                              marginBottom: "4px",
                              lineHeight: "1.3"
                            }}>
                              {reply.attributes?.comment}
                            </div>
                            
                            {reply.attributes?.files && reply.attributes.files.length > 0 && (
                              <CommentImage files={reply.attributes.files} />
                            )}
                            
                            <div style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              backgroundColor: isReplyNotCurrentUser ? "#fff2d2" : "transparent",
                              padding: isReplyNotCurrentUser ? "8px" : "0px",
                              transition: "all 0.3s ease-in-out"
                            }}>
                              <div className={classes.reactionBtn} style={{ fontSize: "10px" }}>
                                <IconButton 
                                  size="small" 
                                  aria-label="reply-likes" 
                                  onClick={() => this.handleReplyLike(reply, item.id)} 
                                  style={{padding:'0px'}}
                                >
                                  <img src={reply.attributes?.already_liked ? redHeart : HeartSmallIcon} style={{ width: "12px", height: "12px", padding:"0px" }} />
                                </IconButton>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  className={classes.likesComments}
                                  style={{ fontSize: "10px" }}
                                >
                                  {reply.attributes?.likes_count || 0}
                                </Typography>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Three-dot menu */}
              <div style={{ marginLeft: "8px" }}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    this.handleClick(e);
                    this.selectedComment = item;
                    this.handleCommentClick(item.attributes?.account_id);
                    this.replyingToName = `${item.attributes?.account?.data?.attributes?.first_name || "User"} ${item.attributes?.account?.data?.attributes?.last_name || ""}`;
                    this.selectedCommentId = item.attributes?.id;
                  }}
                  style={{ padding: "4px" }}
                >
                  <MoreHorizRoundedIcon style={{ fontSize: "16px", color: "#666" }} />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  getMobileCommentInputUI = () => {
    const { classes } = this.props;
    const isMobile = this.isMobile;
    const selectedPost = (this.state as any).selectedPost;

    return (
      <Box style={{
        flexShrink: 0,
        width: "100%",
        padding: "12px 16px",
        borderTop: "1px solid #E2E8F0",
        backgroundColor: "#fff",
        position: "sticky",
        bottom: 0,
        zIndex: 10
      }}>
        {this.commentImage && (
          <Box paddingX={1} style={{ marginBottom: '8px' }}>
            <Box className={classes.commentImagePreviewWrapper}>
              <IconButton
                size="small"
                data-test-id="image-comment-remove"
                onClick={this.handleImageCommentRemove}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
              <img
                src={URL.createObjectURL(this.commentImage)}
                alt="Image"
                data-test-id="comment-image-selected"
                className={classes.commentImage}
              />
            </Box>
          </Box>
        )}
        <Box
          alignItems="center"
          className={classes.postCommentRoot}
          style={{ margin: 0, padding: 0 }}
        >
          <Box>
            <IconButton
              style={{paddingLeft: "8px"}}
              data-test-id="image-comment-upload"
              aria-label="add emoji"
              onClick={this.handleImageCommentClick}
            >
              <img
                src={uploadIcon}
                alt="uploadIcon"
              />
              <input
                ref={this.imageInputRef}
                accept=".jpeg, .jpg, .png"
                type="file"
                hidden
                data-test-id="image-comment-file"
                capture={this.isMobile ? "environment" : undefined}
                onChange={this.handleImageCommentUpload}
              />
            </IconButton>
          </Box>
          <Box className={classes.commentInputBox}>
            <Box>
              <TextField
                data-test-id="commentField"
                placeholder={this.replyingToID ? `Replying to ${this.replyingToName}` : "Add a Comment"}
                inputRef={this.commentRef}
                onBlur={this.handleCommentOnBlur}
                variant="outlined"
                value={this.comment || ""}
                fullWidth
                multiline
                maxRows={6}
                minRows={1}
                name="comment"
                onChange={(e: any) => {
                  this.comment = e.target.value;
                  this.forceUpdate();
                }}
                InputProps={{
                  classes: {
                    root: classes.postCommentTextField,
                    input: classes.postCommentinput,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.placeholder,
                  },
                }}
              />
            </Box>
          </Box>
          <Box className={classes.uploadFileBox}></Box>
          <Box className={clsx("iconStyle", classes.postCommentBox)}>
            <IconButton
              size="small"
              disabled={Boolean(!this.comment && !this.commentImage)}
              data-test-id="postCommentApiCall"
              onClick={this.handleCommentToPost}
            >
              <img src={sendMedssageIcon} alt="sendIcon" />
            </IconButton>
          </Box>
        </Box>
      </Box>
    );
  };

  getMobileCommentPopover = () => {
    const { classes } = this.props;
    const selectedPost = (this.state as any).selectedPost;
    const account_id = selectedPost?.attributes?.account_id || selectedPost?.account_id;
    const openCommentPopover = Boolean(this.anchorEl);
    const commentId = openCommentPopover ? "mobile-comment-menu" : "";

    const StyledMenuItem = withStyles((theme: Theme) =>
      createStyles({
        root: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
      })
    )(MenuItem);

    const isSelfComment = () => {
      return this.selectedComment?.attributes?.account_id === parseInt(localStorage.getItem('userId') || '0');
    };

    return (
      <Popover
        id={commentId}
        open={openCommentPopover}
        anchorEl={this.anchorEl}
        onClose={this.handleClose}
        disablePortal={false}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        classes={{
          paper: classes.popOverPaper,
        }}
        style={{
          zIndex: 10000
        }}
      >
        <StyledMenuItem
          data-test-id="mobile-reply"
          onClick={() => {
            this.handleClose();
            if (this.selectedCommentId) {
              this.handleReplyClick(this.selectedCommentId, this.replyingToName);
            }
          }}
        >
          <ListItemText primary="Reply" />
        </StyledMenuItem>
        <CustomConditionalRender isRender={account_id === parseInt(localStorage.getItem('userId') || '0')}>
          <>
            <StyledMenuItem
              data-test-id="mobile-archive"
              disabled={
                this.selectedCommentId === null ||
                this.archivedStatus[this.selectedCommentId || '']
              }
              onClick={() => {
                this.handleClose();
                const values = {
                  archives: {
                    archiveable_id: this.selectedCommentId,
                    archiveable_type: "BxBlockComments::Comment",
                  },
                };
                this.archiveCommentApiCall(values);
                if (this.selectedCommentId) {
                  this.archivedStatus[this.selectedCommentId] = true;
                }
              }}
            >
              <ListItemText primary="Archive" />
            </StyledMenuItem>
            <StyledMenuItem
              data-test-id="mobile-revert-archive"
              disabled={
                Boolean(this.selectedCommentId &&
                !this.archivedStatus[this.selectedCommentId || ''])
              }
              onClick={() => {
                this.handleClose();
                const values = {
                  archives: {
                    archiveable_id: this.selectedCommentId,
                    archiveable_type: "BxBlockComments::Comment",
                  },
                };
                this.revertArchiveCommentApiCall(values);
                if (this.selectedCommentId) {
                  this.archivedStatus[this.selectedCommentId] = false;
                }
              }}
            >
              <ListItemText primary="Revert archive" />
            </StyledMenuItem>
          </>
        </CustomConditionalRender>
        <CustomConditionalRender isRender={isSelfComment()}>
          <StyledMenuItem
            data-test-id="mobile-delete"
            onClick={() => {
              this.handleClose();
              const postId = selectedPost?.id || selectedPost?.attributes?.id;
              if (this.selectedCommentId && postId) {
                this.deleteCommentApiCall(this.selectedCommentId, postId);
              }
            }}
          >
            <ListItemText primary="Delete" />
          </StyledMenuItem>
        </CustomConditionalRender>
        <CustomConditionalRender isRender={!isSelfComment()}>
          <StyledMenuItem data-test-id="mobile-banUser">
            <ListItemText primary="Ban user" />
          </StyledMenuItem>
        </CustomConditionalRender>
      </Popover>
    );
  };

  handleReplyLike = (replyItem: any, parentCommentId: string) => {
    // Handle reply like logic
    if (replyItem.attributes?.already_liked) {
      this.handleUndoLikeAPICall(replyItem.id, "Comment", (this.state as any).selectedPost?.id);
    } else {
      this.handleLikePostAPICall(replyItem, "Comment");
    }
  };

  // API call IDs for tracking requests
  likePostApiCallId: string = "";
  undoLikeApiCallId: string = "";
  voteApiCallId: string = "";
  deleteVoteApiCallId: string = "";

  // Post interaction methods with proper API calls
  handleVote = async (optionId: number, postId: any) => {
    // Update local state immediately for better UX
    const allPosts: any[] = this.state.postsDataEU || [];
    const postIndex = allPosts.findIndex((p: any) => p.id === postId);
    
    if (postIndex !== -1) {
      const updatedPosts = [...allPosts];
      const post = updatedPosts[postIndex];
      
      if (post.attributes?.poll_options) {
        // Update poll options vote counts
        post.attributes.poll_options.forEach((option: any) => {
          if (option.id === optionId) {
            option.vote_count = (option.vote_count || 0) + 1;
          }
        });
        
        // Update poll user_voted_option_id
        if (post.attributes.poll) {
          post.attributes.poll.user_voted_option_id = optionId;
          post.attributes.poll.total_count = (post.attributes.poll.total_count || 0) + 1;
        }
        
        // Update state
        this.setState({
          postsDataEU: updatedPosts
        } as any);
      }
    }

    // Make API call
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.voteApiCallId = requestMessage.messageId;
    
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${dashboardConfigJSON.getPostsPollApiEndpoint}/${postId}/vote?option_id=${optionId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpPostMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleDeleteVote = async (optionId: number, postId: any) => {
    // Update local state immediately for better UX
    const allPosts: any[] = this.state.postsDataEU || [];
    const postIndex = allPosts.findIndex((p: any) => p.id === postId);
    
    if (postIndex !== -1) {
      const updatedPosts = [...allPosts];
      const post = updatedPosts[postIndex];
      
      if (post.attributes?.poll_options) {
        // Update poll options vote counts
        post.attributes.poll_options.forEach((option: any) => {
          if (option.id === optionId) {
            option.vote_count = Math.max(0, (option.vote_count || 0) - 1);
          }
        });
        
        // Clear poll user_voted_option_id
        if (post.attributes.poll) {
          post.attributes.poll.user_voted_option_id = null;
          post.attributes.poll.total_count = Math.max(0, (post.attributes.poll.total_count || 0) - 1);
        }
        
        // Update state
        this.setState({
          postsDataEU: updatedPosts
        } as any);
      }
    }

    // Make API call
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.deleteVoteApiCallId = requestMessage.messageId;
    
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${dashboardConfigJSON.getPostsPollApiEndpoint}/${postId}/delete_vote?option_id=${optionId}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpDelMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePostProfileClick = (userId: any) => {
    console.log("handlePostProfileClick", userId);
    // TODO: Implement navigation to user profile
  };

  handleUndoLikeAPICall = async (postId: any, type: string, postIdForComment?: string) => {
    // Handle comment unlikes differently
    if (type === "Comment") {
      // Update comment like status immediately
      if (this.comments && this.comments.data) {
        const commentIndex = this.comments.data.findIndex((c: any) => c.id === postId || c.attributes?.id === postId);
        if (commentIndex !== -1) {
          const updatedComments = { ...this.comments };
          updatedComments.data = [...this.comments.data];
          if (updatedComments.data[commentIndex].attributes) {
            updatedComments.data[commentIndex].attributes.already_liked = false;
            updatedComments.data[commentIndex].attributes.likes_count = Math.max(0, (updatedComments.data[commentIndex].attributes.likes_count || 0) - 1);
          }
          this.comments = updatedComments;
          this.forceUpdate();
        }
      }
      
      // Make API call for comment unlike
      const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
      const endPoint = `${dashboardConfigJSON.undoLikeApiEndpoint}?likeable_id=${postId}&likeable_type=${dashboardConfigJSON.likeableTypes[type] || "BxBlockComments::Comment"}`;
      
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.undoLikeCommentApiCallId = requestMessage.messageId;
      
      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        endPoint
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        dashboardConfigJSON.httpDelMethod
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify({
          "Content-Type": dashboardConfigJSON.dashboarContentType,
          token: token
        })
      );
      
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return;
    }
    
    // Update the post in state immediately for better UX
    const allPosts = this.state.postsDataEU || [];
    const postIndex = allPosts.findIndex((p: any) => p.id === postId);
    
    if (postIndex !== -1) {
      const updatedPosts = [...allPosts];
      if (updatedPosts[postIndex].attributes) {
        updatedPosts[postIndex].attributes.is_liked = false;
        updatedPosts[postIndex].attributes.likes_count = Math.max(0, (updatedPosts[postIndex].attributes.likes_count || 0) - 1);
      }
      
      // Update state
      this.setState({
        postsDataEU: updatedPosts
      } as any);
    }

    // Make API call
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    const endPoint = `${dashboardConfigJSON.undoLikeApiEndpoint}?likeable_id=${postId}&likeable_type=${dashboardConfigJSON.likeableTypes[type] || dashboardConfigJSON.PostClass}`;
    
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.undoLikeApiCallId = requestMessage.messageId;
    
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpDelMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleLikePostAPICall = async (post: any, type: string) => {
    // Handle comment likes differently
    if (type === "Comment") {
      // Update comment like status immediately
      if (this.comments && this.comments.data) {
        const commentIndex = this.comments.data.findIndex((c: any) => c.id === post.id || c.attributes?.id === post.id);
        if (commentIndex !== -1) {
          const updatedComments = { ...this.comments };
          updatedComments.data = [...this.comments.data];
          if (updatedComments.data[commentIndex].attributes) {
            updatedComments.data[commentIndex].attributes.already_liked = true;
            updatedComments.data[commentIndex].attributes.likes_count = (updatedComments.data[commentIndex].attributes.likes_count || 0) + 1;
          }
          this.comments = updatedComments;
          this.forceUpdate();
        }
      }
      
      // Make API call for comment like
      const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
      const payload = {
        like: {
          likeable_id: post.id || post.attributes?.id,
          likeable_type: dashboardConfigJSON.likeableTypes[type] || "BxBlockComments::Comment"
        }
      };
      
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.likeCommentApiCallId = requestMessage.messageId;
      
      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        dashboardConfigJSON.likeAPIEndPoint
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        dashboardConfigJSON.httpPostMethod
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify({
          "Content-Type": dashboardConfigJSON.dashboarContentType,
          token: token
        })
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(payload)
      );
      
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return;
    }
    
    // Update the post in state immediately for better UX
    const allPosts = this.state.postsDataEU || [];
    const postIndex = allPosts.findIndex((p: any) => p.id === post.id);
    
    if (postIndex !== -1) {
      const updatedPosts = [...allPosts];
      if (updatedPosts[postIndex].attributes) {
        updatedPosts[postIndex].attributes.is_liked = true;
        updatedPosts[postIndex].attributes.likes_count = (updatedPosts[postIndex].attributes.likes_count || 0) + 1;
      }
      
      // Update state
      this.setState({
        postsDataEU: updatedPosts
      } as any);
    }

    // Make API call
    const token = window.localStorage.getItem('authToken') || window.localStorage.getItem('EUAuthToken');
    const payload = {
      like: {
        likeable_id: post.id,
        likeable_type: dashboardConfigJSON.likeableTypes[type] || dashboardConfigJSON.PostClass
      }
    };
    
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.likePostApiCallId = requestMessage.messageId;
    
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      dashboardConfigJSON.likeAPIEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      dashboardConfigJSON.httpPostMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": dashboardConfigJSON.dashboarContentType,
        token: token
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(payload)
    );
    
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
}

const RootContainer = styled(Box)(({theme}) => ({
  background: "#f1f4f9",
  [theme.breakpoints.down(768)]: {
    background: "#fff"
  },
}))

const styles = (theme: Theme) => createStyles({
  followersCarouselContainer: {
    margin: "20px 0",
    maxHeight: "160px",
  },
  followersCarouselHeading: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#000000",
    marginBottom: "12px",
  },
  followerAvatarBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  followerAvatarImg: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  followerName: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    color: "#334155",
    marginTop: "6px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "70px",
  },
  profileContentWrapper: {
    margin: "15px auto",
    maxWidth: "1240px",
    width: "96%",
    paddingBottom: "80px",
    '@media (max-width: 768px)': {
      '& .asdf': {
        paddingInline: '0px !important'
      }
    }
  },
  top6AndFollowContainer: {
    paddingTop: "0px !important",
    [theme.breakpoints.down(601)]: {
      display: 'none'
    }
  },
  ebSwiperBox: {
    position: "relative",
    height: "auto",
    backgroundColor: "#fff",
    "& .swiper-wrapper": {
      height: "auto"
    },
    width: "auto",
  },
  textIssuesCheck:{
    maxWidth: '100% !important',
    padding: '0px',

  },
  ebEuProfileContainer: {
    position: "relative",
    height: "auto",
    minWidth: "100%",
    margin: "0 auto",
    padding: "0px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  },
  addPersonalityWrapper: {
    backgroundColor: "#fff",
    padding: "10px",
    minWidth: '96%'
  },
  ebSwiperSlideContainer: {
    width: "auto",
    height: "auto",
    "& img": {
      width: "100%",
      height: "500px",
      objectFit: "cover"
    },
  },
  imageOverlay: {
    position: "relative",
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      padding: '0px',
      minWidth: '100%'
    },
    "&::before": {
      content: '""',
      display: 'block',
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 29.36%, rgba(0, 0, 0, 0.8) 116.29%)",
      position:'absolute',
      top:0,
      left:0,
      right:0,
      bottom:0
    }
  },
  top6MobileView:{
    [theme.breakpoints.up(600)]: {
      display: "none"
    },
  },
  profileImageContainer:{
    width: "100%",
    height: "451px",
    borderRadius: "20px 20px 0px 0px",
    background: "#FFC629",
    "@media (max-width: 768px)":{
      height: "276px",
    }
  },
  image: {
    width: '100%',
    height: "100%",
    objectFit: "cover",
    padding: '0px',
    borderRadius: "20px 20px 0px 0px",
  },
  fontWeight: {
    fontWeight: 700,
    fontSize: '12px',
    // marginLeft: '-20px',
    "@media (max-width: 320px)":{
     
    }
  },
  detailsContainer: {
    position: 'absolute', bottom: 35, left: 50,
    zIndex: 2,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap:"5px",
    "& .nameText":{
      fontSize: "30px",
      [theme.breakpoints.down(960)]: {
        fontSize: "20px",
      },
    },
    "& .headline":{
      width: "90%"
    },
    "& .residenceTextContainer":{
      background: "rgba(0,0,0,0.5)",
      paddingLeft: "10px",
      paddingRight: "10px",
      paddingTop: "2px",
      paddingBottom: "2px",
      borderRadius: "24px",
      textAlign: "start",
      display: "inline-block",
      maxWidth: "max-content"
    },
    "@media (max-width: 768px)":{
        fontSize: '10px',
        '& .text-centerChange': {
          fontSize: 16
        }
    },
    [theme.breakpoints.down(768)]: {
      width: "50%",
    },
    [theme.breakpoints.down(960)]: {
      left: "20px"
    },
  },
  editIconContainer: {
    "& svg": {
      position: 'absolute',
      top: 10,
      right: 10,
      color: "#fff",
      width: "20px",
      height: "20px",
      background: "#0F172A",
      borderRadius: "8px",
      textAlign: "center",
      padding: "5px"
    }
  },
  followBtn: {
    maxWidth: "113px",
    background:'#FFC629',
    color:'#000',
    fontWeight:700,fontSize:'15px',
    borderRadius: "30px",
    textTransform: "capitalize",
    padding: "6px 0px",
    marginTop: "10px",
    "&:hover": {
      background:'#FFC629',
      color:'#000',
    },
    "& .MuiButton-label":{
      padding: "4px 0 0"
    }
  },
  followContainer:{
    display: "flex",
    justifyContent: "space-around",
    marginTop: theme.spacing(2),
    textAlign: "center",
    marginBottom: "18px",
    "& .followersFollowingNumber":{
      fontSize: "30px",
      fontWeight: 700,
    },
    position: 'absolute',
    bottom: 35,
    right: 50,
    zIndex: 1,
    alignItems:'center',
    gap:'20px',
    color: "#fff",
    [theme.breakpoints.down(960)]: {
      right: 20
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "center",
      bottom: "14px"
    },
    '@media (max-width: 768px)': {
        display: 'flex',
        flexDirection: 'row',
        fontSize:'12px',
        // marginRight: '-20px'
    },
    '@media (max-width: 320px)': {
      display: 'flex',
      flexDirection: 'row',
      fontSize:'10px',
      marginRight: '-60px'
  }
  },
  sliderBottomContainer: {
    padding: "20px 40px",
    [theme.breakpoints.down(650)]: {
      padding: "4px 20px"
    },
    "& .swiper-button-next ": {
      border: "2px solid",
      padding: "22px",
      zIndex: 4
    },
    "& .swiper-button-next::after": {
      fontSize:"24px",
      fontWeight: "600"
    },
    "& .swiper-button-prev": {
      border: "2px solid",
      padding: "22px",
      zIndex: 4
    },
    "& .swiper-button-prev::after": {
      fontSize:"24px",
      fontWeight: "600"
    }
  },
  subHeading1: {
    fontWeight: 600,
    color: "#FFC629",
    fontSize: "20px",
    [theme.breakpoints.down(950)]: {
      fontSize: "18px",
    },
    [theme.breakpoints.down(650)]: {
      fontSize: "12px",
    },
  },
  subHeading2: {
    fontWeight: 600,
    color: "#000",
    [theme.breakpoints.down(950)]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down(650)]: {
      fontSize: "12px",
    },
  },
  slidesDotsUl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px",
    backgroundColor: "#fff",
    "& li": {
      margin: "0px 15px",
      fontSize: "32px",
    },
  },
  slidesDotsColor: {
    color: "#FFC629 !important"
  },
  postsHeading: {
    fontFamily: "Inter",
    // fontSize: "16px",
    fontWeight: 700,
    lineHeight: "22px",
    // textAlign: "left",
    margin: "20px",
    color: "#0F172A",
    [theme.breakpoints.down(650)]: {
      fontSize: "16px"
    },
  },
  postThumbnailBox: {
    position: 'relative',
    overflow: 'hidden',
    height: "330px",
    [theme.breakpoints.down(650)]: {
      height: "185px"
    },
  },
  swiperBtn: {
    border: "2px solid",
  padding: "22px",
  "&::after": {
    fontSize:"24px",
    fontWeight: "600"
  }
  },
  swiperLeftBtn: {
    position: "absolute",
    top: "50%",
    [theme.breakpoints.down(650)]: {
      display: "none"
    },
  },
  swiperRightBtn:{
    position: "absolute",
    top: "50%",
    right: "0",
    [theme.breakpoints.down(650)]: {
      display: "none"
    },
  },
    // Modal styles to match Instagram Reels style
    previewModal: {
      // background: "rgba(255, 255, 255, 0.2)",
      // backdropFilter: "blur(5px)",
      // For larger screens
      [theme.breakpoints.up("sm")]: {
        // background: "rgba(255, 255, 255, 0.2)",
        // backdropFilter: "blur(5px)",
        zIndex: 1300, // default modal zIndex
      },
      // For mobile (xs and below)
      [theme.breakpoints.down("xs")]: {
        // background: "rgba(255, 255, 255, 0)", 
        // backdropFilter: "none",
        zIndex: `${theme.zIndex.drawer + 1} !important`, // ensures it’s above drawers
      },
    },
    postViewContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'clamp(300px, 40%, 450px)', // responsive width: min 300px, max 450px
      height: '85%',
      maxHeight: '100%',
      color: 'white',
      borderRadius: '40px',
      overflow: 'hidden',
      background: '#000',
      [theme.breakpoints.down(1200)]: {
        width: 'clamp(250px, 55%, 470px)',
      },
      [theme.breakpoints.down(900)]: {
        width: 'clamp(250px, 55%, 450px)',
      },
      // Mobile: Full-screen like Instagram Reels
      [theme.breakpoints.down(650)]: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transform: 'none',
        width: '100vw',
        height: 'calc(100vh - 64px)', // 100vh minus bottom nav bar height
        minHeight: 'calc(100vh - 64px)', // Fallback for older browsers
        maxWidth: '100vw',
        maxHeight: 'calc(100vh - 64px)',
        borderRadius: 0,
        overflow: 'hidden', // Prevent any overflow that might cause extra space
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        paddingTop: 'env(safe-area-inset-top, 0px)',
        '& .videoImageContainer': {
          position: 'relative',
          height: 'calc(100vh - 64px)', // Full viewport height minus bottom nav
          width: '100vw', // Full viewport width like TikTok
          minHeight: 'calc(100vh - 64px)', // Fallback for older browsers
          '& .imageVideoContainer': {
            position: 'relative',
            width: '100vw', // Full viewport width
            height: 'calc(100vh - 64px)', // Full viewport height minus bottom nav
            minHeight: 'calc(100vh - 64px)', // Fallback for older browsers
            overflow: 'hidden',
            '& .mediaContainer': {
              backgroundColor: '#000',
              width: '100vw', // Full viewport width like TikTok
              height: 'calc(100vh - 64px)', // Full viewport height minus bottom nav
              minHeight: 'calc(100vh - 64px)', // Fallback for older browsers
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              '& >img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover', // Cover the entire container like Instagram Reels
              },
              '& >video': {
                width: '100%',
                height: '100%',
                objectFit: 'cover', // Cover the entire container like Instagram Reels
                backgroundColor: '#000',
                objectPosition: 'center', // Center the content
                borderRadius: '0px', // Remove any border radius for full screen
              },
            },
            '& .progressBarOuterContainer': {
              position: 'absolute',
              bottom: '2px',
              zIndex: 2,
              width: '100%',
              '& .progressBar': {
                position: 'relative',
                height: '3px',
                backgroundColor: '#fff',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
                '& .playedPart': {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  backgroundColor: '#FFC629',
                  borderRadius: '5px',
                  transition: 'width 0.1s linear',
                },
                '& .unplayedPart': {
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '8px',
                  height: '8px',
                  backgroundColor: '#FFC629',
                  borderRadius: '50%',
                  transition: 'left 0.1s linear',
                },
              },
            },
          },
          '& .postInfoContainer': {
            position: 'absolute',
            width: '100%',
            bottom: '0px',
            left: '0px',
            right: '0px',
            zIndex: 3, // Action bar layer - higher than poll (2)
            color: '#fff',
            paddingBottom: 'env(safe-area-inset-bottom, 0px)', // Handle iPhone safe area
            background: 'linear-gradient(transparent, rgba(0,0,0,0.3))', // Gradient overlay like Instagram
            padding: '0 16px 20px 16px', // Add padding for better text positioning
            pointerEvents: 'auto', // Ensure clicks work
            '& .tradmard': {
              position: 'absolute',
              bottom: '17px',
              left: '36%',
              display: 'flex',
              alignItems: 'center',
              '& p': {
                fontSize: '8px',
                fontWeight: 'bold',
                color: '#86898D',
              },
              '& img': {
                height: '22px',
              },
            },
          },
          '& .commentSection': {
            // Comment section styles
          },
        },
      },
    },
    previewCloseBtn: {
        position: 'absolute',
        top: '16px',
        right: '16px',
        zIndex: 1000,
        color: '#000',
        background: "#ffffff",
        padding: "3px",
        borderRadius: "50%",
        cursor: "pointer",
        // minWidth: "32px",
        // height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        "&:hover": {
            background: "#ffffff",
            opacity: 0.9,
        },
        "& svg": {
            fontSize: "20px",
        },
    },
    previewBottomWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        padding: '0 16px 20px 16px',
        zIndex: 10,
        minHeight: '120px',
        pointerEvents: 'auto',
        background: 'linear-gradient(transparent, rgba(0,0,0,0.3))',
        [theme.breakpoints.down('xs')]: {
            padding: '0 16px 16px 16px',
            minHeight: '140px',
        }
    },
    reactionContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: "column",
        gap: "12px",
        marginTop: '0px',
        position: 'relative',
        zIndex: 1,
        pointerEvents: 'auto',
    },
    avatar: {
        height: "35px",
        width: "35px",
        borderRadius: "50%",
    },
    fallbackAvatar: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "50%",
    },
    postDescripation: {
        marginTop: '5px',
        fontFamily: "Inter",
        fontSize: "14px",
        lineHeight: "1.4",
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: '100%',
        textShadow: "0 1px 2px rgba(0,0,0,0.8)",
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        color: '#fff',
        [theme.breakpoints.down('xs')]: {
            fontSize: "14px",
            lineHeight: "1.5",
            marginBottom: '8px',
            paddingRight: '10px',
            fontWeight: "500",
            textShadow: "0 1px 3px rgba(0,0,0,0.9)",
        },
    },
    postDescripationExpanded: {
        display: 'block',
        WebkitLineClamp: 'unset',
        WebkitBoxOrient: 'unset',
        overflow: 'visible'
    },
    commentIconWhite: {
        width: "24px",
        height: "24px",
    },
    postSettingsBtn: {
        color: 'white',
        padding: '4px',
    },
    postPreviewComments: {
      position: 'absolute',
      bottom: '7%', // ✅ stick to the bottom of parent container
      left: '50%',
      transform: 'translateX(-50%)', // ✅ center horizontally only
      width: 'clamp(300px, 40%, 450px)',
      maxHeight: '45%', // ✅ responsive height
      background: 'white',
      borderRadius: '20px 0px 40px 40px',
      overflowY: 'hidden', // ✅ prevent modal from scrolling
      display: 'flex', // ✅ flexbox layout
      flexDirection: 'column', // ✅ vertical layout
      padding: '0px 10px',
      [theme.breakpoints.down(1200)]: {
        width: 'clamp(250px, 55%, 470px)',
      },

      [theme.breakpoints.down(900)]: {
        width: 'clamp(250px, 55%, 450px)',
      },
      [theme.breakpoints.down(600)]: {
        width: 'clamp(220px, 75%, 400px)',
        height: '80%',
        maxHeight: '80%',
        borderRadius: '20px',
      },
      [theme.breakpoints.down(400)]: {
        width: 'clamp(200px, 90%, 360px)',
        height: '80%',
        maxHeight: '80%',
        borderRadius: '16px',
      },
    },
    commentSectionContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        width: "100%",
        overflow: "hidden",
        height: "100%",
        [theme.breakpoints.down(950)]: {
            padding: "0",
        }
    },
    commentCloseIconWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        margin: "10px 0px",
        flexShrink: 0,
        "& > button": {
            padding: "0px",
            border: "1px solid #E2E8F0"
        }
    },
    commentsContentWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
    },
    pollCommentsWrapper: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        padding: "0 16px",
        WebkitOverflowScrolling: "touch",
        scrollBehavior: "smooth",
        "&::-webkit-scrollbar": {
            width: "6px",
            background: "transparent"
        },
        "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#cbd5e1",
            borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#94a3b8"
        },
        [theme.breakpoints.down(768)]: {
            padding: "0 20px",
            "&::-webkit-scrollbar": {
                width: "0px",
                background: "transparent"
            },
        },
    },
    commentscardHeader: {
        display: "flex",
    },
    cardHeaderContent: {
        flex: 1,
    },
    cardHeaderContentOfResponsiveContainer: {
        flex: 1,
        opacity: 0.5,
        pointerEvents: "none",
    },
    commentCardHeaderAction: {
        paddingTop: "6px",
        paddingRight: "42px",
        "& button": {
            transform: "rotate(90deg)",
        },
        [theme.breakpoints.down(1100)]: {
            paddingRight: "8px"
        },
        [theme.breakpoints.down(480)]: {
            paddingRight: "0px"
        }
    },
    commentCardActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3),
        paddingLeft: "60px",
        marginBottom: "20px",
        "& button": {
            padding: "0px"
        },
        [theme.breakpoints.down(950)]: {
            paddingLeft: "48px",
        }
    },
    commentReplyCardActions: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        paddingLeft: "150px",
        marginBottom: "10px",
        "& button": {
            padding: "0px"
        }
    },
    reactionBtn: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        paddingBottom: 0
    },
    replyExpandIcon: {
        transition: "transform 0.3s"
    },
    replyExpandedIcon: {
        transform: "rotate(180deg)",
    },
    likesComments: {
        color: "#64748B",
        fontFamily: "Inter",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "22px",
        [theme.breakpoints.down(950)]: {
            fontSize: "12px"
        }
    },
    viewComments: {
        color: "#64748B",
        cursor: "pointer",
        fontFamily: "Inter",
        fontSize: "10px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "22px",
    },
    popOverPaper: {
        padding: "4px 4px 2px 4px",
        borderRadius: "8px",
        border: "1px solid #E2E8F0",
        minWidth: "192px",
        background: "#FFF",
        boxShadow: "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
    },
    postCommentRoot: {
        display: "flex",
        width: "100%",
        flexShrink: 0,
    },
    commentInputBox: {
        width: "80%"
    },
    uploadFileBox: {
        width: "1%",
    },
    postCommentBox: {
        width: "15%"
    },
    commentImagePreviewWrapper: {
        position: "relative",
        margin: "5px 0px",
        height: "50px",
        width: "50px",
        "& > button": {
            position: "absolute",
            top: "-9px",
            right: "-8px",
            backgroundColor: "#ffca29",
            padding: "1px",
            "&:hover": {
                backgroundColor: "#ffca29"
            },
            "& svg": {
                fontSize: "1.1rem",
                color: "#000"
            }
        }
    },
    commentImage: {
        height: "100%",
        width: "100%",
        borderRadius: "8px",
        marginTop: "3px",
        cursor: "pointer"
    },
    postCommentTextField: {
        "& .MuiOutlinedInput-root": {
            minHeight: "40px",
            maxHeight: "120px",
            "& textarea": {
                minHeight: "40px !important",
                maxHeight: "100px",
                overflowY: "auto !important",
            }
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E2E8F0",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #000"
        },
        borderRadius: "0px 16px 16px 16px",
        backgroundColor: "#F8FAFC",
        borderColor: "#F0F3F8",
    },
    postCommentinput: {
        "&::placeholder": {
            fontFamily: "Inter",
            fontSize: "16px",
            fontWeight: 400,
            fontStyle: "normal",
            color: "#64748B",
        },
    },
    commnetSectionUser: {
        color: "#0F172A",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 700,
        fontFamily: "Inter",
        [theme.breakpoints.down(950)]: {
            fontSize: "12px"
        }
    },
    commentTime: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Inter",
        fontStyle: "normal",
        color: "#64748B",
        marginLeft: "6px",
        [theme.breakpoints.down(950)]: {
            fontSize: "12px"
        }
    },
    commentFonts: {
        color: "#0F172A",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        fontFamily: "Inter",
        wordBreak: "break-word",
        whiteSpace: "pre-line",
        [theme.breakpoints.down(950)]: {
            fontSize: "14px"
        }
    },
    placeholder: {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: 400,
        color: "#64748B",
    },
});

export default withStyles(styles)(EuuserProfile);
